import {
Component,
OnInit,
Input,
ContentChild,
ElementRef,
ViewChild,
AfterViewInit,
NgZone
} from "@angular/core";
import { Observable, of } from "rxjs";
import { NumberFormatStyle } from "@angular/common";
import { IndexKind } from "typescript";
import { prependListener } from "process";
import { analyzeFileForInjectables } from "@angular/compiler";
import { getHostElement } from "@angular/core/src/render3";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
interface Shape {
iterations: number;
expand: number;
angle: number;
}
@Component({
  selector: "artbycoloring-canvas",
  templateUrl: "./canvas.component.html",
  styleUrls: ["./canvas.component.css"]
})
export class CanvasComponent implements OnInit {
  event: PointerEvent | null = null;
  clientX = 0;
  clientY = 0;
  sliderArray = [];
  selectedArray = [];
  safeSvgContent: SafeHtml | null = null;
  onEvent(event: PointerEvent): void {
    this.event = event;
  }

  coordinates(event: PointerEvent): void {
    this.clientX = event.clientX;
    this.clientY = event.clientY;

    if (this.clientX < 1250) {
      this.playgroundX = Math.round((1250 - event.clientX) * -4);
    } else if (this.clientX > 1250) {
      this.playgroundX = Math.round((event.clientX - 1250) * 4);
    }
    if (this.clientY < 450) {
      this.playgroundY = Math.round((450 - event.clientY) * -4);
    } else if (this.clientY > 450) {
      this.playgroundY = Math.round((event.clientY - 450) * 4);
    }
  }

  hoverPreviewShapeId = "";
  hoverPreviewOriginalShapeName = "";
  committedShapeName = "";
  stageToFront: boolean = false;

  toggleStageFront(): void {
    this.stageToFront = !this.stageToFront;
  }

  private getStableRandom(min: number, max: number, key: string): number {
    if (max <= min) {
      return min;
    }

    let hash = 0;
    for (let index = 0; index < key.length; index++) {
      hash = ((hash << 5) - hash + key.charCodeAt(index)) | 0;
    }

    const normalized = Math.abs(Math.sin(hash));
    return Math.floor((normalized - Math.floor(normalized)) * (max - min + 1)) + min;
  }

  commitShapeFromEvent(event: MouseEvent): void {
    const button = (event.target as HTMLElement).closest("button.shapebutton") as HTMLButtonElement;
    if (!button) {
      return;
    }
    const shapeId = this.getPreviewShapeId(button);
    if (shapeId) {
      this.committedShapeName = shapeId;
      this.hoverPreviewOriginalShapeName = shapeId;
    }
  }

  showShapePreviewFromEvent(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target) {
      return;
    }

    const button = target.closest("button.shapebutton") as HTMLButtonElement;
    if (!button) {
      return;
    }

    const previewShapeId = this.getPreviewShapeId(button);
    if (!previewShapeId) {
      return;
    }

    if (!this.hoverPreviewShapeId) {
      this.hoverPreviewOriginalShapeName = this.shapeName;
    }

    this.hoverPreviewShapeId = previewShapeId;
    this.shapeName = previewShapeId;
  }

  clearShapePreview(): void {
    this.hoverPreviewShapeId = "";

    const restoreTo = this.committedShapeName || this.hoverPreviewOriginalShapeName;
    if (restoreTo) {
      this.shapeName = restoreTo;
    }
    this.hoverPreviewOriginalShapeName = "";
  }

  private getPreviewShapeId(button: HTMLButtonElement): string {
    const label = (button.textContent || "").trim();
    if (!label) {
      return "";
    }

    if (label.toLowerCase().startsWith("open ")) {
      const placeName = label.substring(5).trim().toLowerCase();
      return placeName ? "#" + placeName : "";
    }

    return "#" + label.replace(/\s+/g, "");
  }

  @Input() aLayers: number;
  all: number[];
  alpha: number;
  alphap: string;
  Arr = Array;
  artData: string;
  artplace: string;
  ascale: string;
  ascaleit: number;
  ascaleitString: string;
  ascaleitValue: number;
  ascaleX: number;
  ascalex: string;
  ascaleXString: string;
  ascaleXValue: number;
  ascaleY: number;
  ascaleYString: string;
  ascaleYValue: number;
  askewX: number;
  askewx: string;
  askewXString: string;
  askewXValue: number;
  askewY: number;
  askewy: string;
  askewYString: string;
  askewYValue: number;
  astart: string;
  atype: string;
  avalues: string;
  backg: number;
  backgAlpha: number;
  backgColorString: string;
  backgHue: number;
  backgSat: number;
  backgVal: number;
  base: string;
  playground: any;
  playground1: boolean;
  playgroundX: number;
  playgroundY: number;
  basemoveh: any;
  basemovev: any;
  baserotate: any;
  basescale: any;
  basescaleX: any;
  basescaleY: any;
  baseskewX: any;
  baseskewY: any;
  baseuse: boolean;
  bezcode: string;
  centerX: number;
  centerY: number;
  centx: number;
  centy: number;
  changeit: any;
  click: boolean;
  clickX: number;
  clickY: number;
  closecurve: boolean;
  codeline: any;
  codestorage: string;
  codestring: string;
  collection: string;
  hue: number;
  sat: number;
  val: number;
  colorNumber: number;
  colors: any;
  color: any;
  colorString: any;
  counter: number;
  cskax: number;
  cskay: number;
  currentColor: string;
  currentFill: string;
  curvecode: string;
  curvestring: string;
  cx: number;
  cy: number;
  dx: number;
  dy: number;
  default: number;
  deltak: number;
  deltal: number;
  deltam: number;
  direction: String;
  duplicateShape: boolean;
  durspeed: number;
  endaddress: string;
  factor: Array<string>;
  factors: Array<string>;
  factorvalue: Array<string>;
  file: any;
  filenamein: string;
  filenameout: string;
  fileShape: string = "fileShape";
  fillColorString: string;
  garage: string;
  garage1: boolean;
  gendx: number;
  gendy: number;
  gend: boolean;
  shader1: boolean;
  shader2: boolean;
  shaderpercent: number;
  shadercode: any;
  hue1: number;
  hue2: number;
  huep: string;
  hsvColor1: any;
  hsvColor2: any;
  hsvColor3: any;
  hsvColor4: any;
  i: number;
  iexpand: number;
  imove: number;
  imoveh: number;
  imovehString: string;
  imovehValue: number;
  imovev: number;
  imovevString: string;
  imovevValue: number;
  info: Array<string>;
  irock: number;
  irotate: number;
  irotateString: string;
  iscale: number;
  iscaleit: number;
  iscaleitString: string;
  iscaleitValue: number;
  iscaleString: string;
  iscaleValue: number;
  iscaleX: number;
  iscaleXString: string;
  iscaleXValue: number;
  iscaleY: number;
  iscaleYString: string;
  iscaleYValue: number;
  iskewX: number;
  iskewXString: string;
  iskewXValue: number;
  iskewY: number;
  iskewYString: string;
  iskewYValue: number;
  item: string;
  itransformString: string;
  itranslateString: string;
  kitchen: string;
  kitchen1: boolean;
  lastMoveX: number;
  lastMoveY: number;
  layers: number;
  layerssize: boolean;
  lockbackg: boolean;
  lockshader: boolean;
  lockscale: boolean;
  lockShape: boolean;
  lockStroke: boolean;
  lockzoom: boolean;
  k: number;
  maxx: number;
  maxy: number;
  middys: string;
  minx: number;
  miny: number;
  modifyit: Array<number>;
  moveShape: boolean;
  moveX: number;
  moveY: number;
  myaction: string;
  myboundinbgbox: string;
  mybox: HTMLElement;
  mycenter: string;
  mycentered: string;
  myclose: string;
  mycolor: string;
  mycontainer: any;
  mycurve: string;
  mydisplay: string;
  myend: string;
  myFreeze: number;
  myshader: string;
  myshader2: string;
  mygroup: boolean;
  myShadeColor: Array<any>;
  myShadeColor2: Array<any>;
  myClasses:Array<any>;
  mymirror: string;
  myname: string;
  mynum: number;
  myout: string;
  mypalette: string;
  myplace: string;
  myscalex: boolean;
  myscaley: boolean;
  myshape: any;
  myshapelist: any;
  mysteps: number;
  myStop: number;
  mysvgfile: string;
  mytoken: string;
  myvalues: string;
  name: string;
  newbase: string;
  newDemo: string;
  newName: string;
  newProject: string;
  newshape: string = "diamondv";
  nlength: number;
  numberShapes: number;
  numpnt: string;
  objectData: string;
  offset: any;
  outbase: any;
  outdata: string;
  output: any;
  outputSpeedString: string;
  outputSpreadString: string;
  paletteColor: string;
  paletteString: string;
  part1: string;
  part2: string;
  partslength: number;
  partsString: string[];
  partsValue: number[];
  pasteArtDataString: string;
  pasteImagecodeString: string;
  pastePaletteString: string;
  pasteSVGcodeString: string;
  pladeFill: string;
  paletteshader: any;
  paletteshader1: boolean;
  basement: any;
  basement1: boolean;
  basementX: number;
  basementY: number;
  playspace: any;
  plength: number;
  polycode: string;
  polyshape: string = "polyshape";
  presetsbox: boolean;
  qshape: string;
  quadcode: string;
  r: number;
  randomAlphaValue: boolean;
  randomartdata: string;
  randomColor: boolean;
  randomhue: boolean;
  randomsat: boolean;
  randomval: boolean;
  randomalpha: boolean;
  randomshade2Value: boolean;
  randomHueValue: boolean;
  randomHValue: boolean;
  randomLayers: boolean;
  randomRotateValue: boolean;
  randomSatValue: boolean;
  randomScaleValue: boolean;
  randomSkewXValue: boolean;
  randomSkewYValue: boolean;
  randomString: string;
  randomStrokevalue: boolean;
  randomStrokeWidthValue: boolean;
  randomValValue: boolean;
  randomVValue: boolean;
  re: any;
  rememberArtData: string;
  rgbColor: string;
  rgbColor1: string;
  rgbColor2: string;
  rgbColor3: string;
  rgbColor4: string;
  roman: string = "roman";
  rorx: number;
  rory: number;
  rotateString: string;
  rotateValue: number;
  satp: string;
  scale: number;
  scaleX: number;
  scaleY: number;
  scaleString: string;
  selectedColor: any;
  selectedElement: boolean;
  selectedMyElement: any;
  shadeFill: string = "";
  shadeFill2: string = "";
  shade1: number;
  shade2: number;
  shade3: number;
  shade4: number;
  shape: string;
  shapeArray: Array<string>;
  shadeart: string;
  shapecode: string;
  shapeData: string;
  shapeID: string;
  shapeName: string;
  shapes: Observable<Shape[]>;
  showArtData: boolean = false;
  showcurve: string;
  showData: string;
  showtom0: boolean = false;
  showShape: boolean = false;
  showsvgData: boolean = false;
  showPalette: boolean = false;
  skax: number;
  skay: number;
  skewXString: string;
  skewXValue: number;
  skewYString: string;
  skewYValue: number;
  slideAlpha: boolean;
  slidebackground: boolean;
  slideFreeze: boolean;
  slideHorizontal: boolean;
  slideHue: boolean;
  slideLayers: boolean;
  slider: any;
  slideRotate: boolean;
  slideSat: boolean;
  slideScale: boolean;
  slideScaleX: boolean;
  slideScaleY: boolean;
  slideSkewX: boolean;
  slideSkewY: boolean;
  slideSpread: boolean;
  slideStrokeColor: boolean;
  slideStrokeWidth: boolean;
  slideVal: boolean;
  slideVertical: boolean;
  slideZoom: boolean;
  spreadsize: number;
  squareif: string;
  sskax: number;
  sskay: number;
  stageHalf: number;
  stageSize: number;
  startaddress: string;
  stopcolor1: string;
  stopcolor2: string;
  stopcolor3: string;
  stopcolor4: string;
  stopmyarray: boolean;
  stopmyslide: boolean;
  stroke: number;
  strokeAlpha: number;
  strokeColorString: string;
  strokeHue: number;
  strokeSat: number;
  strokeString: string;
  strokeVal: number;
  strokeWidth: number;
  strokeWidthString: string;
  svg: any;
  svgx: string;
  svgy: string;
  svgContent: string;
  svgheight: string;
  svgShapes: any;
  svgstage: string;
  svgviewbox: string;
  svgwidtth: string;
  sx: number;
  sy: number;
  th: number;
  tv: number;
  thing: string;
  tom: any;
  tooltipsEnabled: boolean;
  transform: any;
  transformString: string;
  translateHValue: number;
  translateString: string;
  translateVValue: number;

  tskax: number;
  typetextString: string;
  useArtObjectsbox: boolean;
  usecontainersbox: boolean;
  useGradient2: boolean;
  usepalettebox: boolean;
  usepresetsbox: boolean;
  useShadeNormal: boolean;
  useShadePalette: boolean;
  useShadePlayground: boolean;
  usePaletteShade: boolean;
  usePaletteNormal: boolean;
  usePaletteplayground: boolean;
  usePastePaletteShade: boolean;
  usePastePaletteNormal: boolean;
  usePastePalettePlayground: boolean;
  useToolTips: boolean;
  valp: string;
  xlist: number[];
  x: number;
  xx: number[];
  ylist: number[];
  y: number;
  yy: number[];
  yy0: number;
  yy1: number;
  yy10: number;
  yy11: number;
  yy2: number;
  yy3: number;
  yy4: number;
  yy5: number;
  yy6: number;
  yy7: number;
  yy8: number;
  yy9: number;
  zoomsize: number;
  zoomflag: number;
  selectionBox: any;
  startY: number;
  startX: number;
  activeSelection: SVGGraphicsElement[] = [];
  selectionBoundingBoxUpdater?: () => void;
  playgroundSelectionApplier?: (elements: SVGGraphicsElement[], asGroupedObject: boolean) => void;
  playgroundShapeCounter: number;
  selectedPlaygroundTarget: string;
  selectedPlaygroundShapeId: string;
  playgroundAnimationMode: boolean;
  playgroundAnimationDuration: number;
  playgroundAnimationStartDelay: number;
  playgroundAnimationEndHold: number;
  playgroundAnimationReturn: boolean;
  playgroundAnimationMirror: boolean;
  showAnimationQuickBox: boolean;

  constructor(private sanitizer: DomSanitizer, private ngZone: NgZone) {
    // Sanitize the SVG content before binding it
  }
  ngOnInit() {
    var mybox = document.getElementById("backlot");
   // mybox.addEventListener("click", this.polyit);
    this.shapes = of([
      { id: 1, iterations: 18, angle: 15, expand: 47 },
      { id: 2, iterations: 36, angle: 11, expand: 33 }
    ]);
    this.setValues();
    this.svgstage = this.convertStageSize(this.stageSize);
    this.selectedColor = { r: 100, g: 130, b: 150, a: this.alpha };
    this.irotate = 0;
    this.imove = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.iscale = 1;
    this.iscaleX = 1;
    this.iscaleY = 1;
    this.iskewX = 0;
    this.iskewY = 0;

    this.squareif = 'SQUARE';
    this.showAnimationQuickBox = false;
    this.enableShapeSelection();
    this.assignPlaygroundShapeIds();
    
    // Initialize drag functionality
    setTimeout(() => {
      const playspaceElement = document.getElementById('playspace');
      const sandlotElement = document.getElementById('sandlot');
      
      if (playspaceElement) {
        this.makeDraggable(playspaceElement);
      }
      if (sandlotElement) {
        this.makeDraggable(sandlotElement);
      }
    }, 100);
    
    // Expose makeDraggable to window for onload event
    (window as any).makeDraggable = (event: any) => {
      if (event && event.target) {
        this.makeDraggable(event.target);
      }
    };
  }

  //////////////////////////

  //////////////////////////

  private makeDraggable(svg: any) {
    let selectedElement: SVGGraphicsElement | null = null;
    let selectedElements: SVGGraphicsElement[] = [];
    let offset: any = null;
    let transform: SVGTransform | null = null;
    let selectionBox: any = null;
    let groupBoundingBox: any = null;
    let selectionStart: any = null;
    let isSelecting = false;
    let isDraggingGroup = false;

    const syncSelectionState = () => {
      this.activeSelection = selectedElements.filter(
        (element): element is SVGGraphicsElement => element instanceof SVGGraphicsElement
      );

      if (this.activeSelection.length > 0) {
        this.selectedShape = this.activeSelection[0];
        const selectedId = this.selectedShape.getAttribute('data-playground-shape-id') || this.selectedShape.id || '';
        this.selectedPlaygroundShapeId = selectedId;
      } else {
        this.selectedShape = null;
        this.selectedPlaygroundShapeId = '';
      }
    };

    const setDragCursor = (isActive: boolean) => {
      const cursor = isActive ? 'grabbing' : '';
      svg.style.cursor = cursor;
      document.body.style.cursor = cursor;
    };

    const getMousePosition = (event: any) => {
      const CTM = svg.getScreenCTM();
      if (event.touches) { event = event.touches[0]; }
      return {
        x: (event.clientX - CTM.e) / CTM.a,
        y: (event.clientY - CTM.f) / CTM.d
      };
    };

    const getOrCreateTranslate = (element: SVGGraphicsElement): SVGTransform | null => {
      const ownerSvg = element.ownerSVGElement || svg;
      if (!ownerSvg || typeof ownerSvg.createSVGTransform !== 'function') {
        return null;
      }

      const transforms = element.transform.baseVal;
      let translate: SVGTransform;

      if (transforms.numberOfItems === 0 || transforms.getItem(0).type !== SVGTransform.SVG_TRANSFORM_TRANSLATE) {
        translate = ownerSvg.createSVGTransform();
        translate.setTranslate(0, 0);
        try {
          transforms.insertItemBefore(translate, 0);
        } catch (error) {
          transforms.appendItem(translate);
        }
      } else {
        translate = transforms.getItem(0);
      }

      this.ensureInitialTranslationMetadata(element, translate.matrix.e, translate.matrix.f);

      return translate;
    };

    const updateGroupBoundingBox = () => {
      if (selectedElements.length === 0) {
        if (groupBoundingBox && groupBoundingBox.parentNode) {
          groupBoundingBox.parentNode.removeChild(groupBoundingBox);
        }
        groupBoundingBox = null;
        return;
      }

      const svgCTM = svg.getScreenCTM();
      if (!svgCTM || typeof svgCTM.inverse !== 'function') {
        return;
      }

      const inverseCTM = svgCTM.inverse();
      const svgPoint = svg.createSVGPoint ? svg.createSVGPoint() : null;
      let minX = Infinity;
      let minY = Infinity;
      let maxX = -Infinity;
      let maxY = -Infinity;

      selectedElements.forEach(el => {
        try {
          const clientRect = el.getBoundingClientRect();
          const corners = [
            { x: clientRect.left, y: clientRect.top },
            { x: clientRect.right, y: clientRect.top },
            { x: clientRect.left, y: clientRect.bottom },
            { x: clientRect.right, y: clientRect.bottom }
          ];

          corners.forEach(corner => {
            const point = svgPoint ? svgPoint : { x: 0, y: 0, matrixTransform: () => corner };
            point.x = corner.x;
            point.y = corner.y;
            const svgCoord = point.matrixTransform(inverseCTM);
            minX = Math.min(minX, svgCoord.x);
            minY = Math.min(minY, svgCoord.y);
            maxX = Math.max(maxX, svgCoord.x);
            maxY = Math.max(maxY, svgCoord.y);
          });
        } catch (e) {
          // Skip elements that can't be measured
        }
      });

      if (!isFinite(minX) || !isFinite(minY) || !isFinite(maxX) || !isFinite(maxY)) {
        return;
      }

      if (!groupBoundingBox) {
        groupBoundingBox = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        groupBoundingBox.setAttribute('class', 'group-bounding-box');
        groupBoundingBox.setAttribute('fill', 'none');
        groupBoundingBox.setAttribute('stroke', 'blue');
        groupBoundingBox.setAttribute('stroke-width', '3');
        groupBoundingBox.setAttribute('stroke-dasharray', '10,5');
        groupBoundingBox.setAttribute('pointer-events', 'none');
        svg.appendChild(groupBoundingBox);
      }

      const padding = 10;
      groupBoundingBox.setAttribute('x', (minX - padding).toString());
      groupBoundingBox.setAttribute('y', (minY - padding).toString());
      groupBoundingBox.setAttribute('width', (maxX - minX + 2 * padding).toString());
      groupBoundingBox.setAttribute('height', (maxY - minY + 2 * padding).toString());
    };

    const clearSelection = () => {
      selectedElements.forEach(el => {
        el.classList.remove('selected');
        el.style.outline = '';
      });
      selectedElements = [];
      syncSelectionState();
      if (selectionBox && selectionBox.parentNode) {
        selectionBox.parentNode.removeChild(selectionBox);
        selectionBox = null;
      }
      if (groupBoundingBox && groupBoundingBox.parentNode) {
        groupBoundingBox.parentNode.removeChild(groupBoundingBox);
        groupBoundingBox = null;
      }
    };

    const selectTargetElement = (target: SVGGraphicsElement) => {
      clearSelection();
      selectedElements = [target];
      target.classList.add('selected');
      target.style.outline = '2px solid blue';
      this.activeSelection = [target];
      this.selectedShape = target;
      this.selectedPlaygroundShapeId =
        target.getAttribute('data-playground-shape-id') || target.id || '';
      setTimeout(() => updateGroupBoundingBox(), 10);
    };

    const startDrag = (event: any) => {
      const coord = getMousePosition(event);
      const isPlaygroundSvg = svg.id === 'sandlot';
      if (isPlaygroundSvg) {
        this.assignPlaygroundShapeIds();
      }
      const playgroundTarget = isPlaygroundSvg ? this.getPlaygroundSelectableElement(event.target) : null;
      const rawTarget = event.target as SVGGraphicsElement;
      const targetElement = (playgroundTarget || rawTarget) as SVGGraphicsElement;
      
      // Check if clicking on a draggable element
      if (targetElement && targetElement.classList && targetElement.classList.contains('draggable')) {
        // If Shift key is held, add to selection
        if (event.shiftKey) {
          const target = targetElement;
          if (!selectedElements.includes(target)) {
            selectedElements.push(target);
            target.classList.add('selected');
            target.style.outline = '2px solid blue';
            updateGroupBoundingBox();
            syncSelectionState();
          }
          return;
        }
        
        // If element is already in selection, drag the group
        if (selectedElements.includes(targetElement)) {
          isDraggingGroup = true;
          offset = coord;
          setDragCursor(true);
          event.preventDefault();
          return;
        }
        
        // Single element drag
        selectedElement = targetElement;
        if (targetElement instanceof SVGGraphicsElement) {
          selectTargetElement(targetElement);
        } else {
          clearSelection();
        }
        offset = coord;
        setDragCursor(true);
        
        transform = selectedElement ? getOrCreateTranslate(selectedElement) : null;
        if (transform) {
          offset.x -= transform.matrix.e;
          offset.y -= transform.matrix.f;
        }
      } else {
        // Start selection box if clicking on empty space
        clearSelection();
        isSelecting = true;
        selectionStart = coord;
        
        // Create selection rectangle
        selectionBox = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        selectionBox.setAttribute('class', 'selection-box');
        selectionBox.setAttribute('x', coord.x.toString());
        selectionBox.setAttribute('y', coord.y.toString());
        selectionBox.setAttribute('width', '0');
        selectionBox.setAttribute('height', '0');
        selectionBox.setAttribute('fill', 'rgba(0, 120, 255, 0.1)');
        selectionBox.setAttribute('stroke', 'blue');
        selectionBox.setAttribute('stroke-width', '2');
        selectionBox.setAttribute('stroke-dasharray', '5,5');
        selectionBox.setAttribute('pointer-events', 'none');
        svg.appendChild(selectionBox);
      }
    };

    const drag = (event: any) => {
      if (isDraggingGroup && selectedElements.length > 0) {
        event.preventDefault();
        const coord = getMousePosition(event);
        const dx = coord.x - offset.x;
        const dy = coord.y - offset.y;
        
        selectedElements.forEach(el => {
          const translate = getOrCreateTranslate(el);
          if (translate) {
            translate.setTranslate(translate.matrix.e + dx, translate.matrix.f + dy);
          }
        });
        
        offset = coord;
        updateGroupBoundingBox();
      } else if (selectedElement) {
        event.preventDefault();
        const coord = getMousePosition(event);
        if (!transform) {
          transform = selectedElement ? getOrCreateTranslate(selectedElement) : null;
        }
        if (transform) {
          transform.setTranslate(coord.x - offset.x, coord.y - offset.y);
        }
      } else if (isSelecting && selectionBox) {
        event.preventDefault();
        const coord = getMousePosition(event);
        const x = Math.min(selectionStart.x, coord.x);
        const y = Math.min(selectionStart.y, coord.y);
        const width = Math.abs(coord.x - selectionStart.x);
        const height = Math.abs(coord.y - selectionStart.y);
        
        selectionBox.setAttribute('x', x.toString());
        selectionBox.setAttribute('y', y.toString());
        selectionBox.setAttribute('width', width.toString());
        selectionBox.setAttribute('height', height.toString());
      }
    };

    const endDrag = (event: any) => {
      if (isSelecting && selectionBox) {
        // Find all draggable elements within selection box
        const boxRect = selectionBox.getBBox();
        const playground = document.getElementById('playground');
        
        // Remove selection box FIRST before checking elements
        if (selectionBox.parentNode) {
          selectionBox.parentNode.removeChild(selectionBox);
        }
        selectionBox = null;
        
        if (playground) {
          const draggables = svg.id === 'sandlot'
            ? playground.querySelectorAll('[data-playground-shape-id]')
            : playground.querySelectorAll('.draggable');
          Array.from(draggables).forEach((el: any) => {
            try {
              const elRect = el.getBBox();
              // Check if element overlaps with selection box
              const overlaps = !(elRect.x > boxRect.x + boxRect.width ||
                                elRect.x + elRect.width < boxRect.x ||
                                elRect.y > boxRect.y + boxRect.height ||
                                elRect.y + elRect.height < boxRect.y);
              
              if (overlaps) {
                selectedElements.push(el as SVGGraphicsElement);
                el.classList.add('selected');
                el.style.outline = '2px solid blue';
              }
            } catch (e) {
              // Skip elements that can't be measured
            }
          });
        }
        
        // Show group bounding box after selection is complete
        if (selectedElements.length > 0) {
          setTimeout(() => updateGroupBoundingBox(), 10);
        }
        syncSelectionState();
      } else if (isDraggingGroup) {
        // Keep the group bounding box visible after drag
        setTimeout(() => updateGroupBoundingBox(), 10);
      }
      
      selectedElement = null;
      isSelecting = false;
      isDraggingGroup = false;
      setDragCursor(false);
    };

    const handleClickSelection = (event: MouseEvent) => {
      if (svg.id !== 'sandlot') {
        return;
      }

      this.assignPlaygroundShapeIds();
      const target = this.getPlaygroundSelectableElement(event.target);
      if (target) {
        selectTargetElement(target);
      }
    };

    const killDrag = (event: any) => {
      const isPlaygroundSvg = svg.id === 'sandlot';
      const playgroundTarget = isPlaygroundSvg ? this.getPlaygroundSelectableElement(event.target) : null;
      const targetElement = (playgroundTarget || event.target) as SVGGraphicsElement;

      if (targetElement && targetElement.classList && targetElement.classList.contains('draggable')) {
        const shouldDelete = confirm("Delete this shape?");
        if (!shouldDelete) {
          return;
        }

        selectedElement = targetElement;
        selectedElement.remove();
        selectedElements = selectedElements.filter(element => element !== targetElement);
        if (this.selectedShape === targetElement) {
          this.selectedShape = null;
          this.selectedPlaygroundShapeId = '';
        }

        if (selectedElements.length > 0) {
          setTimeout(() => updateGroupBoundingBox(), 10);
        } else if (groupBoundingBox && groupBoundingBox.parentNode) {
          groupBoundingBox.parentNode.removeChild(groupBoundingBox);
          groupBoundingBox = null;
        }

        syncSelectionState();
      }
    };

    this.selectionBoundingBoxUpdater = updateGroupBoundingBox;

    if (svg.id === 'sandlot') {
      this.playgroundSelectionApplier = (elements: SVGGraphicsElement[], asGroupedObject: boolean) => {
        clearSelection();

        selectedElements = elements.filter(
          (element): element is SVGGraphicsElement =>
            element instanceof SVGGraphicsElement && svg.contains(element)
        );

        selectedElements.forEach(element => {
          element.classList.add('selected');
          element.style.outline = '2px solid blue';
        });

        syncSelectionState();

        if (asGroupedObject && selectedElements.length > 0) {
          setTimeout(() => updateGroupBoundingBox(), 10);
        }
      };
    }

    const shouldPreserveSelection = (target: EventTarget | null): boolean => {
      if (!(target instanceof Element)) {
        return false;
      }
      return Boolean(target.closest('[data-preserve-selection]'));
    };

    const handleExternalClick = (event: MouseEvent) => {
      if (!svg.contains(event.target as Node) && !shouldPreserveSelection(event.target)) {
        clearSelection();
      }
    };

    document.addEventListener('mousedown', handleExternalClick);

    svg.addEventListener('mousedown', startDrag);
    this.ngZone.runOutsideAngular(() => {
      svg.addEventListener('mousemove', drag);
      svg.addEventListener('touchmove', drag);
    });
    svg.addEventListener('mouseup', endDrag);
    svg.addEventListener('mouseleave', endDrag);
    svg.addEventListener('touchstart', startDrag);
    svg.addEventListener('touchend', endDrag);
    svg.addEventListener('touchleave', endDrag);
    svg.addEventListener('touchcancel', endDrag);
    svg.addEventListener('click', handleClickSelection);
    svg.addEventListener('dblclick', killDrag);
  }

  //////////////////////////

  private centerSelectedShapes(elements: any[]): void {
    const svgElements = elements.filter((element): element is SVGGraphicsElement =>
      element instanceof SVGGraphicsElement
    );

    if (!svgElements.length) {
      console.warn('No SVG elements available for centering');
      return;
    }

    const result = this.centerGraphics(svgElements);
    if (!result) {
      console.warn('Unable to center selection due to invalid bounds');
      return;
    }

    console.log(`Centered ${svgElements.length} element(s) by (${result.translateX}, ${result.translateY})`);
  }

  public onCenterPlayground(): void {
    this.centerPlayground();
  }

  //////////////////////////
  //////////////////////////

    private centerGraphics(
    elements: SVGGraphicsElement[]
  ): { translateX: number; translateY: number } | null {
    if (!elements.length) {
      return null;
    }

    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;

    elements.forEach(element => {
      const bounds = this.computeTransformedBounds(element);
      if (bounds) {
        minX = Math.min(minX, bounds.x);
        minY = Math.min(minY, bounds.y);
        maxX = Math.max(maxX, bounds.x + bounds.width);
        maxY = Math.max(maxY, bounds.y + bounds.height);
      } else {
        console.warn('Skipping element during centering due to measurement error', element);
      }
    });

    if (!isFinite(minX) || !isFinite(minY) || !isFinite(maxX) || !isFinite(maxY)) {
      return null;
    }

    const centerX = (minX + maxX) / 2;
    const centerY = (minY + maxY) / 2;
    const offsetX = -centerX;
    const offsetY = -centerY;

    elements.forEach(element => {
      try {
        this.applyGlobalTranslation(element, offsetX, offsetY);
      } catch (error) {
        console.warn('Unable to apply centering transform', error, element);
      }
    });

    return { translateX: offsetX, translateY: offsetY };
  }

  private computeTransformedBounds(
    element: SVGGraphicsElement
  ): { x: number; y: number; width: number; height: number } | null {
    const svg = element.ownerSVGElement;
    if (!svg) {
      return null;
    }

    let bbox: DOMRect | SVGRect;
    try {
      bbox = element.getBBox();
    } catch (error) {
      console.warn('Unable to measure element bounds', error, element);
      return null;
    }

    const matrix = element.getCTM();
    if (!matrix) {
      return { x: bbox.x, y: bbox.y, width: bbox.width, height: bbox.height };
    }

    const transformPoint = (x: number, y: number) => {
      const point = svg.createSVGPoint();
      point.x = x;
      point.y = y;
      return point.matrixTransform(matrix);
    };

    const topLeft = transformPoint(bbox.x, bbox.y);
    const topRight = transformPoint(bbox.x + bbox.width, bbox.y);
    const bottomLeft = transformPoint(bbox.x, bbox.y + bbox.height);
    const bottomRight = transformPoint(bbox.x + bbox.width, bbox.y + bbox.height);

    const xs = [topLeft.x, topRight.x, bottomLeft.x, bottomRight.x];
    const ys = [topLeft.y, topRight.y, bottomLeft.y, bottomRight.y];

    const minX = Math.min(...xs);
    const minY = Math.min(...ys);
    const maxX = Math.max(...xs);
    const maxY = Math.max(...ys);

    return { x: minX, y: minY, width: maxX - minX, height: maxY - minY };
  }

  private applyGlobalTranslation(element: SVGGraphicsElement, deltaX: number, deltaY: number): void {
    if (!deltaX && !deltaY) {
      return;
    }

    const svg = element.ownerSVGElement;
    if (!svg) {
      return;
    }

    const baseTransforms = element.transform.baseVal;
    if (baseTransforms.numberOfItems === 0) {
      const translate = svg.createSVGTransform();
      translate.setTranslate(deltaX, deltaY);
      baseTransforms.appendItem(translate);
      return;
    }

    const consolidated = baseTransforms.consolidate();
    if (!consolidated) {
      const translate = svg.createSVGTransform();
      translate.setTranslate(deltaX, deltaY);
      baseTransforms.appendItem(translate);
      return;
    }

    const matrix = consolidated.matrix;
    const translationMatrix = svg.createSVGMatrix().translate(deltaX, deltaY);
    const newMatrix = translationMatrix.multiply(matrix);
    consolidated.setMatrix(newMatrix);
  }

  private getSvgDataset(element: SVGElement): DOMStringMap | undefined {
    return (element as SVGElement & { dataset?: DOMStringMap }).dataset;
  }

  private ensureInitialTranslationMetadata(
    element: SVGGraphicsElement,
    defaultX: number = 0,
    defaultY: number = 0
  ): void {
    const dataset = this.getSvgDataset(element);
    if (!dataset) {
      element.setAttribute('data-initial-translate-x', defaultX.toString());
      element.setAttribute('data-initial-translate-y', defaultY.toString());
      return;
    }

    if (dataset.initialTranslateX === undefined) {
      dataset.initialTranslateX = defaultX.toString();
    }

    if (dataset.initialTranslateY === undefined) {
      dataset.initialTranslateY = defaultY.toString();
    }
  }

  private createPlaygroundShapeId(): string {
    this.playgroundShapeCounter = (this.playgroundShapeCounter || 0) + 1;
    return `playground-shape-${this.playgroundShapeCounter}`;
  }

  private ensurePlaygroundShapeIdentity(element: SVGGraphicsElement): void {
    if (!element.classList.contains('draggable')) {
      element.classList.add('draggable');
    }
    if (!element.classList.contains('playground-shape')) {
      element.classList.add('playground-shape');
    }

    let shapeId = element.getAttribute('data-playground-shape-id') || '';
    if (!shapeId) {
      shapeId = this.createPlaygroundShapeId();
      element.setAttribute('data-playground-shape-id', shapeId);
    }
    if (!element.id) {
      element.id = shapeId;
    }
  }

  private assignPlaygroundShapeIds(): void {
    const playground = document.getElementById('playground');
    if (!playground) {
      return;
    }

    const children = Array.from(playground.children).filter(
      (element): element is SVGGraphicsElement => element instanceof SVGGraphicsElement
    );

    children.forEach(child => this.ensurePlaygroundShapeIdentity(child));
  }

  private getPlaygroundSelectableElement(target: EventTarget | null): SVGGraphicsElement | null {
    if (!(target instanceof Element)) {
      return null;
    }

    const playground = document.getElementById('playground');
    if (!playground) {
      return null;
    }

    const shapeElement = target.closest('[data-playground-shape-id]');
    if (shapeElement instanceof SVGGraphicsElement && playground.contains(shapeElement)) {
      return shapeElement;
    }

    return null;
  }

  private getPlaygroundTargets(): SVGGraphicsElement[] {
    const playground = document.getElementById('playground');
    if (!playground) {
      return [];
    }

    this.assignPlaygroundShapeIds();

    if (this.selectedPlaygroundTarget === 'group') {
      return this.activeSelection.filter(
        (element): element is SVGGraphicsElement =>
          element instanceof SVGGraphicsElement &&
          playground.contains(element) &&
          Boolean(element.getAttribute('data-playground-shape-id'))
      );
    }

    if (this.selectedPlaygroundTarget === 'selected') {
      if (this.selectedShape && playground.contains(this.selectedShape)) {
        return [this.selectedShape];
      }

      if (this.selectedPlaygroundShapeId) {
        const byId = playground.querySelector(`#${this.selectedPlaygroundShapeId}`);
        if (byId instanceof SVGGraphicsElement) {
          return [byId];
        }
      }

      if (this.activeSelection.length > 0) {
        return this.activeSelection.filter(
          (element): element is SVGGraphicsElement =>
            element instanceof SVGGraphicsElement && playground.contains(element)
        ).slice(0, 1);
      }

      return [];
    }

    return Array.from(playground.querySelectorAll('[data-playground-shape-id]')).filter(
      (element): element is SVGGraphicsElement => element instanceof SVGGraphicsElement
    );
  }

  private buildPlaygroundTransformString(
    target: SVGGraphicsElement,
    rotate: number,
    scale: number,
    scaleX: number,
    scaleY: number,
    skewX: number,
    skewY: number,
    moveH: number,
    moveV: number,
    sharedRotateCenter?: { x: number; y: number }
  ): string {
    const appliedScaleX = scaleX * scale;
    const appliedScaleY = scaleY * scale;
    const rotateCenter = sharedRotateCenter
      ? (this.transformGlobalPointToTargetLocal(target, sharedRotateCenter) || this.getPlaygroundRotationCenter(target))
      : this.getPlaygroundRotationCenter(target);

    if (sharedRotateCenter) {
      return (
        `rotate(${rotate},${rotateCenter.x},${rotateCenter.y}) ` +
        `translate(${rotateCenter.x},${rotateCenter.y}) ` +
        `scale(${appliedScaleX},${appliedScaleY}) ` +
        `skewX(${skewX}) ` +
        `skewY(${skewY}) ` +
        `translate(${-rotateCenter.x},${-rotateCenter.y}) ` +
        `translate(${moveH},${moveV})`
      );
    }

    return (
      `rotate(${rotate},${rotateCenter.x},${rotateCenter.y}) ` +
      `scale(${appliedScaleX},${appliedScaleY}) ` +
      `skewX(${skewX}) ` +
      `skewY(${skewY}) ` +
      `translate(${moveH},${moveV})`
    );
  }

  private getPlaygroundRotationCenter(target: SVGGraphicsElement): { x: number; y: number } {
    try {
      const box = target.getBBox();
      return {
        x: box.x + (box.width / 2),
        y: box.y + (box.height / 2)
      };
    } catch (error) {
      return { x: this.gendx, y: this.gendy };
    }
  }

  private getPlaygroundGroupRotationCenter(targets: SVGGraphicsElement[]): { x: number; y: number } | null {
    const sandlotElement = document.getElementById('sandlot');
    const sandlot = sandlotElement instanceof SVGSVGElement ? sandlotElement : null;
    if (!sandlot) {
      return null;
    }

    const center = this.getSandlotViewportCenter(sandlot);
    return { x: center.x, y: center.y };
  }

  private transformGlobalPointToTargetLocal(
    target: SVGGraphicsElement,
    globalPoint: { x: number; y: number }
  ): { x: number; y: number } | null {
    const svg = target.ownerSVGElement;
    if (!svg || !svg.createSVGPoint) {
      return null;
    }

    const sandlotElement = document.getElementById('sandlot');
    const sandlot = sandlotElement instanceof SVGSVGElement ? sandlotElement : svg;
    const sandlotScreenMatrix = sandlot.getScreenCTM();
    const targetScreenMatrix = target.getScreenCTM();
    if (
      !sandlotScreenMatrix ||
      !targetScreenMatrix ||
      typeof targetScreenMatrix.inverse !== 'function'
    ) {
      return null;
    }

    const point = sandlot.createSVGPoint();
    point.x = globalPoint.x;
    point.y = globalPoint.y;

    try {
      const screenPoint = point.matrixTransform(sandlotScreenMatrix);
      const localPoint = screenPoint.matrixTransform(targetScreenMatrix.inverse());
      if (!isFinite(localPoint.x) || !isFinite(localPoint.y)) {
        return null;
      }
      return { x: localPoint.x, y: localPoint.y };
    } catch (error) {
      return null;
    }
  }

  private applyTransformMarkupToTarget(
    target: SVGGraphicsElement,
    transformValue: string,
    shouldDuplicate: boolean
  ): void {
    const baseMarkup = target.innerHTML;
    const transformedMarkup = `<g transform="${transformValue}">${baseMarkup}</g>`;

    if (shouldDuplicate) {
      target.innerHTML = baseMarkup + transformedMarkup;
      return;
    }

    target.innerHTML = transformedMarkup;
  }

  private removePlaygroundAnimation(target: SVGGraphicsElement, animationType?: string): void {
    let selector = 'animateTransform[data-playground-animation="true"]';
    if (animationType) {
      selector += `[type="${animationType}"]`;
    }
    const existing = target.querySelectorAll(selector);
    Array.prototype.forEach.call(existing, (node: Element) => {
      if (node.parentNode) {
        node.parentNode.removeChild(node);
      }
    });
  }

  private stopAllPlaygroundAnimations(): void {
    const playground = document.getElementById('playground');
    if (!playground) {
      return;
    }

    const targets = Array.from(playground.querySelectorAll('[data-playground-shape-id]')).filter(
      (element): element is SVGGraphicsElement => element instanceof SVGGraphicsElement
    );

    targets.forEach(target => this.removePlaygroundAnimation(target));
  }

  private onPlaygroundAnimationModeChange(enabled: boolean): void {
    if (!enabled) {
      this.stopAllPlaygroundAnimations();
    }
  }

  private onPlaygroundAnimationSettingsChange(): void {
    if (!this.playgroundAnimationMode) {
      return;
    }

    const targets = this.getPlaygroundTargets();
    if (!targets.length) {
      return;
    }

    const hasActiveAnimation = targets.some(target =>
      !!target.querySelector('animateTransform[data-playground-animation="true"]')
    );

    if (!hasActiveAnimation) {
      return;
    }

    this.doit();
  }

  private showAnimationControlsInQuickBox(): void {
    this.showAnimationQuickBox = true;
    this.scrollToElement('quicknavigationblock');
    setTimeout(() => {
      this.scrollToElement('actiontools');
    }, 120);
    setTimeout(() => {
      this.scrollToElement('actiontools');
    }, 260);
  }

  private showQuickNavigationBox(): void {
    this.showAnimationQuickBox = false;
    this.scrollToElement('quicknavigationblock');
  }

  private addPlaygroundAnimation(
    target: SVGGraphicsElement,
    type: string,
    fromValue: string,
    toValue: string,
    mirroredValueOverride?: string
  ): void {
    this.removePlaygroundAnimation(target, type);

    const animation = document.createElementNS('http://www.w3.org/2000/svg', 'animateTransform');
    const oneWayDuration = Math.max(0.1, this.playgroundAnimationDuration || 0.1);
    const startDelay = Math.max(0, this.playgroundAnimationStartDelay || 0);
    const endHold = Math.max(0, this.playgroundAnimationEndHold || 0);
    const useMirror = this.playgroundAnimationMirror === true;
    const mirroredToValue = mirroredValueOverride || this.getMirroredAnimationValue(type, toValue);

    animation.setAttribute('attributeName', 'transform');
    animation.setAttribute('type', type);
    if (this.playgroundAnimationReturn) {
      const totalDuration = (oneWayDuration * 2) + endHold;
      const forwardEnd = oneWayDuration / totalDuration;
      const returnStart = (oneWayDuration + endHold) / totalDuration;
      if (useMirror) {
        animation.setAttribute('values', `${toValue};${mirroredToValue};${mirroredToValue};${toValue}`);
      } else {
        animation.setAttribute('values', `${fromValue};${toValue};${toValue};${fromValue}`);
      }
      animation.setAttribute('keyTimes', `0;${forwardEnd};${returnStart};1`);
      animation.setAttribute('dur', `${totalDuration}s`);
    } else {
      if (useMirror) {
        animation.setAttribute('from', toValue);
        animation.setAttribute('to', mirroredToValue);
      } else {
        animation.setAttribute('from', fromValue);
        animation.setAttribute('to', toValue);
      }
      animation.setAttribute('dur', `${oneWayDuration}s`);
    }
    animation.setAttribute('repeatCount', 'indefinite');
    animation.setAttribute('fill', 'freeze');
    animation.setAttribute('begin', `${startDelay}s`);
    animation.setAttribute('additive', 'sum');
    animation.setAttribute('data-playground-animation', 'true');
    target.appendChild(animation);
  }

  private degreesToRadians(value: number): number {
    return (value * Math.PI) / 180;
  }

  private buildScaleAroundCenterMatrixValue(scaleX: number, scaleY: number, center: { x: number; y: number }): string {
    const e = center.x - (center.x * scaleX);
    const f = center.y - (center.y * scaleY);
    return `${scaleX} 0 0 ${scaleY} ${e} ${f}`;
  }

  private buildSkewXAroundCenterMatrixValue(skewX: number, center: { x: number; y: number }): string {
    const tangent = Math.tan(this.degreesToRadians(skewX));
    const e = -tangent * center.y;
    return `1 0 ${tangent} 1 ${e} 0`;
  }

  private buildSkewYAroundCenterMatrixValue(skewY: number, center: { x: number; y: number }): string {
    const tangent = Math.tan(this.degreesToRadians(skewY));
    const f = -tangent * center.x;
    return `1 ${tangent} 0 1 0 ${f}`;
  }

  private getMirroredAnimationValue(type: string, value: string): string {
    const parts = value.trim().split(/\s+/);
    const numbers = parts.map(part => parseFloat(part));

    if (type === 'rotate') {
      if (numbers.length >= 3) {
        return `${-numbers[0]} ${numbers[1]} ${numbers[2]}`;
      }
      return `${-numbers[0]}`;
    }

    if (type === 'translate' || type === 'scale') {
      if (numbers.length >= 2) {
        return `${-numbers[0]} ${-numbers[1]}`;
      }
      return `${-numbers[0]}`;
    }

    if (type === 'skewX' || type === 'skewY') {
      return `${-numbers[0]}`;
    }

    return value;
  }

  private applyPlaygroundAnimation(
    target: SVGGraphicsElement,
    rotate: number,
    scale: number,
    scaleX: number,
    scaleY: number,
    skewX: number,
    skewY: number,
    moveH: number,
    moveV: number,
    sharedRotateCenter?: { x: number; y: number }
  ): void {
    const appliedScaleX = scaleX * scale;
    const appliedScaleY = scaleY * scale;
    const rotateCenter = sharedRotateCenter
      ? (this.transformGlobalPointToTargetLocal(target, sharedRotateCenter) || this.getPlaygroundRotationCenter(target))
      : this.getPlaygroundRotationCenter(target);
    const shouldTreatAsGroupedObject = this.selectedPlaygroundTarget === 'group' && !!sharedRotateCenter;

    if (moveH !== 0 || moveV !== 0) {
      this.addPlaygroundAnimation(target, 'translate', '0 0', `${moveH} ${moveV}`);
    }
    if (rotate !== 0) {
      this.addPlaygroundAnimation(target, 'rotate', `0 ${rotateCenter.x} ${rotateCenter.y}`, `${rotate} ${rotateCenter.x} ${rotateCenter.y}`);
    }
    if (appliedScaleX !== 1 || appliedScaleY !== 1) {
      if (shouldTreatAsGroupedObject) {
        const toValue = this.buildScaleAroundCenterMatrixValue(appliedScaleX, appliedScaleY, rotateCenter);
        const mirroredScaleX = -appliedScaleX;
        const mirroredScaleY = -appliedScaleY;
        const mirroredValue = this.buildScaleAroundCenterMatrixValue(mirroredScaleX, mirroredScaleY, rotateCenter);
        this.addPlaygroundAnimation(target, 'matrix', '1 0 0 1 0 0', toValue, mirroredValue);
      } else {
        this.addPlaygroundAnimation(target, 'scale', '1 1', `${appliedScaleX} ${appliedScaleY}`);
      }
    }
    if (skewX !== 0) {
      if (shouldTreatAsGroupedObject) {
        const toValue = this.buildSkewXAroundCenterMatrixValue(skewX, rotateCenter);
        const mirroredValue = this.buildSkewXAroundCenterMatrixValue(-skewX, rotateCenter);
        this.addPlaygroundAnimation(target, 'matrix', '1 0 0 1 0 0', toValue, mirroredValue);
      } else {
        this.addPlaygroundAnimation(target, 'skewX', '0', `${skewX}`);
      }
    }
    if (skewY !== 0) {
      if (shouldTreatAsGroupedObject) {
        const toValue = this.buildSkewYAroundCenterMatrixValue(skewY, rotateCenter);
        const mirroredValue = this.buildSkewYAroundCenterMatrixValue(-skewY, rotateCenter);
        this.addPlaygroundAnimation(target, 'matrix', '1 0 0 1 0 0', toValue, mirroredValue);
      } else {
        this.addPlaygroundAnimation(target, 'skewY', '0', `${skewY}`);
      }
    }
  }

  private applyPlaygroundOperation(
    rotate: number,
    scale: number,
    scaleX: number,
    scaleY: number,
    skewX: number,
    skewY: number,
    moveH: number,
    moveV: number
  ): void {
    const targets = this.getPlaygroundTargets();
    if (!targets.length) {
      return;
    }

    const sharedRotateCenter = this.selectedPlaygroundTarget === 'group'
      ? this.getPlaygroundGroupRotationCenter(targets)
      : null;

    const applySpreadOffsets = targets.length > 1;
    targets.forEach((target, index) => {
      let spreadOffsetH = 0;
      let spreadOffsetV = 0;

      if (applySpreadOffsets) {
        const angle = (Math.PI * 2 * index) / targets.length;
        spreadOffsetH = this.spreadsize * Math.cos(angle);
        spreadOffsetV = this.spreadsize * Math.sin(angle);
      }

      const effectiveMoveH = moveH + spreadOffsetH;
      const effectiveMoveV = moveV + spreadOffsetV;

      if (this.playgroundAnimationMode) {
        this.applyPlaygroundAnimation(
          target,
          rotate,
          scale,
          scaleX,
          scaleY,
          skewX,
          skewY,
          effectiveMoveH,
          effectiveMoveV,
          sharedRotateCenter || undefined
        );
      } else {
        const transformValue = this.buildPlaygroundTransformString(
          target,
          rotate,
          scale,
          scaleX,
          scaleY,
          skewX,
          skewY,
          effectiveMoveH,
          effectiveMoveV,
          sharedRotateCenter || undefined
        );
        this.applyTransformMarkupToTarget(target, transformValue, this.duplicateShape === true);
      }
    });

    const playgroundElement = document.getElementById('playground');
    this.showData = playgroundElement ? playgroundElement.innerHTML : '';

    this.shapeName = '#playground';
    this.shapeID = this.setShape(this.shapeName);
  }

  private resetElementToInitialTranslation(element: SVGGraphicsElement): void {
    const svg = element.ownerSVGElement;
    if (!svg) {
      return;
    }

    const transforms = element.transform.baseVal;
    let translate: SVGTransform;

    if (transforms.numberOfItems === 0 || transforms.getItem(0).type !== SVGTransform.SVG_TRANSFORM_TRANSLATE) {
      translate = svg.createSVGTransform();
      translate.setTranslate(0, 0);
      try {
        transforms.insertItemBefore(translate, 0);
      } catch (error) {
        transforms.appendItem(translate);
      }
    } else {
      translate = transforms.getItem(0);
    }

    const dataset = this.getSvgDataset(element);
    let initialXValue = element.getAttribute('data-initial-translate-x');
    let initialYValue = element.getAttribute('data-initial-translate-y');

    if (dataset) {
      if (dataset.initialTranslateX !== undefined) {
        initialXValue = dataset.initialTranslateX;
      }
      if (dataset.initialTranslateY !== undefined) {
        initialYValue = dataset.initialTranslateY;
      }
    }
    const initialX = initialXValue ? parseFloat(initialXValue) : 0;
    const initialY = initialYValue ? parseFloat(initialYValue) : 0;

    translate.setTranslate(initialX, initialY);
  }

  private centerPlayground(): void {
    const playground = document.getElementById('playground');
    if (!playground || !(playground instanceof SVGGElement)) {
      console.warn('Playground element not found');
      return;
    }

    this.assignPlaygroundShapeIds();
    let elementsToCenter = this.getPlaygroundTargets();

    if (this.selectedPlaygroundTarget === 'selected' && !elementsToCenter.length) {
      elementsToCenter = Array.from(playground.querySelectorAll('[data-playground-shape-id]')).filter(
        (element): element is SVGGraphicsElement => element instanceof SVGGraphicsElement
      );
    }

    if (!elementsToCenter.length) {
      console.warn('Playground has no shapes to center');
      return;
    }

    const result = this.centerGraphics(elementsToCenter);
    if (!result) {
      console.warn('Unable to center playground targets due to invalid bounds');
      return;
    }

    this.activeSelection = elementsToCenter;

    if (this.selectionBoundingBoxUpdater) {
      setTimeout(() => {
        if (this.selectionBoundingBoxUpdater) {
          this.selectionBoundingBoxUpdater();
        }
      }, 10);
    }

    console.log(
      `Centered ${elementsToCenter.length} playground element(s) as a group by (${result.translateX}, ${result.translateY})`
    );
  }

  //////////////////////////
  //////////////////////////

  private toggleSquareMode() {
    if (this.squareif === 'SQUARE') {
      this.squareif = 'ROUND';
    } else if (this.squareif === 'ROUND') {
      this.squareif = 'BOXES';
    } else {
      this.squareif = 'SQUARE';
    }
  }

  private toggleSquareModeAndCenterStage(): void {
    this.toggleSquareMode();
    this.squareit();
    setTimeout(() => {
      this.centerStage();
    }, 0);
  }

  //////////////////////////

  private patternAtStep(step: number): { step: number; group: number; delta: number; xExpr: string; yExpr: string } {
    if (step < 0 || !Number.isInteger(step)) {
      throw new Error("step must be a non-negative integer");
    }

    // Step 0 special-case
    if (step === 0) {
      return { step, group: 0, delta: 0, xExpr: "x=x+0", yExpr: "y=y+0" };
    }

    // Convert to "move index" m = 1.. (step 1 is the 1st move row)
    let m = step; // since step 1 => m=1, step 2 => m=2, ...

    // Find group by subtracting each group's run length (which equals delta)
    // group: 1,2,3,4,5,6,...
    // delta: 1,1,2,2,3,3,...
    let group = 1;
    while (true) {
      const delta = Math.ceil(group / 2);
      if (m <= delta) {
        // m falls within this group
        const d = delta;
        const sign = (d % 2 === 1) ? "+" : "-";     // odd delta => +, even => -
        const isXMove = (group % 2 === 1);          // odd group => X, even => Y

        const xExpr = isXMove ? `x=x${sign}spread` : "x=x+0";
        const yExpr = isXMove ? "y=y+0" : `y=y${sign}spread`;

        return { step, group, delta: d, xExpr, yExpr };
      }
      m -= Math.ceil(group / 2);
      group++;
    }
  }

  //////////////////////////
  private setValues() {

//////////// artData values //////////////
    this.shapeName = "#newshape";
    this.numberShapes = 1;
    this.layers = 145;
    this.spreadsize = 220;
    //////////////////////////
    this.rotateValue = 0;
    this.scale = 1;
    this.scaleX = 0.03;
    this.scaleY = 0.03;
    this.skewXValue = 0;
    this.skewYValue = 0;
    this.translateHValue = -1200;
    this.translateVValue = -1400;
    this.gendx = -500;
    this.gendy = -500;
    this.zoomsize = 1;
    ///////////////////
    this.shade1 = 120;
    this.shade2 = 280;
    this.shade3 = 10;
    this.shade4 = 110;
    ///////////////////
    this.hue = 90;
    this.sat = 100;
    this.val = 100;
    this.alpha = 1;
    this.stroke = 0;
    this.strokeWidth = 2;
    this.backg = 0;
    ////////////////// ////////////////////
    this.aLayers = 360;
    this.all = [];
    this.alphap = "1";
    this.artData = "";
    this.artplace = "";
    this.ascale;
    this.ascaleit = 0;
    this.ascaleitString = "0";
    this.ascaleitValue = 0;
    this.ascaleX = 0.9;
    this.ascaleXString = "0.9";
    this.ascaleXValue = 0.9;
    this.ascaleY = 0.9;
    this.ascaleYString = "0.9";
    this.ascaleYValue = 0.9;
    this.askewX = 20;
    this.askewXString = "20";
    this.askewXValue = 20;
    this.askewY = 20;
    this.askewYString = "20";
    this.askewYValue = 20;
    this.atype = "rotate";
    this.avalues = "0";
    this.backgAlpha = 1;
    this.backgColorString = "360";
    this.backgHue = 0;
    this.backgSat = 100;
    this.backgVal = 100;
    this.base = "";
    this.basemoveh = 0;
    this.basemovev = 0;
    this.baserotate = 0;
    this.basescale = 1;
    this.basescaleX = 1;
    this.basescaleY = 1;
    this.baseskewX = 0;
    this.baseskewY = 0;
    this.baseuse = false;
    this.centx = 0;
    this.centy = 0;
    this.click = false;
    this.clickX = 0;
    this.clickY = 0;
    this.closecurve = false;
    this.codestorage = "";
    this.colorNumber = 0;
    this.colors = Array;
    this.colorString = Array;
    this.counter = 0;
    this.cskax = 0;
    this.cskay = 0;
    this.currentColor = "#F0F0F0FF";
    this.currentFill = "";
    this.cx = 0;
    this.cy = 0;
    this.default = 5;
    this.deltak = 0;
    this.deltal = 0;
    this.deltam = 0;
    this.direction = "";
    this.duplicateShape = false;
    this.durspeed = 20;
    this.dx = 0;
    this.dy = 0;
    this.endaddress = '"></image>';
    this.factor = [];
    this.factors;
    this.factorvalue;
    this.filenamein = "art.txt";
    this.filenameout = "art.txt";
    this.garage = '<polygone points="0,0 200.0 0,20>';
    this.garage1 = false;
    this.gend = true;
    this.hsvColor1 = [10, 100, 100, 1];
    this.hsvColor2 = [100, 100, 100, 1];
    this.hsvColor3 = [110, 100, 100, 1];
    this.hsvColor4 = [200, 100, 100, 1];
    this.huep = "0";
    this.iexpand = 4;
    this.imove = 0;
    this.imoveh = 0;
    this.imoveh, (this.imovehString = "0");
    this.imovehValue = 0;
    this.imovev;
    this.imovev = 0;
    this.imovevString = "0";
    this.imovevValue = 0;
    this.info = [""];
    this.irotate = 0;
    this.iscale = 0.5;
    this.iscaleString = "0";
    this.iscaleValue = 0;
    this.iscaleX = 1;
    this.iscaleXValue = 0.9;
    this.iscaleY = 1;
    this.iscaleYValue = 0.9;
    this.iskewX = 0;
    this.iskewXValue = 20;
    this.iskewY = 0;
    this.iskewYValue = 20;
    this.item = "";
    this.k = 1;
    this.kitchen = '<rect x=" 0" y="0" width="300" height="100"></rect>';
    this.kitchen1 = false;
    this.lastMoveX = 0;
    this.lastMoveY = 0;
    this.layerssize = false;
    this.lockbackg = false;
    this.lockscale = true;
    this.lockshader = false;
    this.lockShape = false;
    this.lockStroke = false;
    this.maxx = 0;
    this.maxy = 0;
    this.middys = "";
    this.minx = 0;
    this.miny = 0;
    this.moveShape = true;
    this.moveX = 0;
    this.moveY = 0;
    this.myaction = "rotate";
    this.myboundinbgbox = "";
    this.mycenter = "";
    this.mycentered = "";
    this.myclose = 'z"></path>';
    this.mycolor = "";
    this.mycontainer = "kitchen";
    this.mycurve = '<path class="draggable" d=" ';
    this.mydisplay = "";
    this.myFreeze = 0;
    this.mygroup = false;
    this.mymirror = "";
    this.myname = "playground";
    this.mynum = 0;
    this.myout = "";
    this.myplace = "#" + this.myname;
    this.myscalex = false;
    this.myscaley = false;
    this.myShadeColor = [this.hsvColor1, this.hsvColor2];
    this.myShadeColor2 = [this.hsvColor3, this.hsvColor4];
    this.myClasses =  [
      "group", "group-fill", "group-stroke", "group-opacity", "group-dash",
      "group-filter", "group-clip", "group-mask", "group-visibility",
      "group-display", "group-pulse", "text-anim", "group-color",
      "group-shape", "group-blend", "group-isolate"
    ];
    this.myshader = "";
    this.myshape = "<line 0,0 700,700 />";
    this.myshapelist = [];
    this.mysteps = 30;
    this.myStop = 1;
    this.mysvgfile = "";
    this.mytoken = "Ba";
    this.myvalues = "360";
    this.newbase = "";
    this.newDemo = "demoDemo";
    this.newName = "";
    this.nlength = 0;
    this.numpnt = "";
    this.objectData = "";
    this.offset = 0;
    this.outdata = "";
    this.outputSpeedString = "1s";
    this.outputSpreadString = "";
    this.paletteColor = "10,100,100,1";
    this.paletteString = "";
    this.part1 = "";
    this.part2 = "";
    this.partslength = 0;
    this.partsString = [];
    this.partsValue = [];
    this.pasteArtDataString = "";
    this.pasteImagecodeString = "";
    this.pastePaletteString = "";
    this.pasteSVGcodeString = "";
    this.playground = "";
    this.playground1 = false;
    this.playgroundX = this.clientX - 1250;
    this.playgroundY = this.clientY - 450;
    this.playspace = "";
    this.plength = 3;
    this.presetsbox = false;
    this.randomalpha = false;
    this.randomAlphaValue = false;
    this.randomartdata = "";
    this.randomColor = false;
    this.randomhue = false;
    this.randomHueValue = false;
    this.randomHValue = false;
    this.randomLayers = false;
    this.randomRotateValue = false;
    this.randomsat = false;
    this.randomSatValue = false;
    this.randomScaleValue = false;
    this.randomshade2Value = false;
    this.randomSkewXValue = false;
    this.randomSkewYValue = false;
    this.randomStrokevalue = false;
    this.randomStrokeWidthValue = false;
    this.randomval = false;
    this.randomValValue = false;
    this.randomVValue = false;
let re = "";
    this.rememberArtData = "";
    this.rgbColor = "rgba(" + 255 + "," + 255 + "," + 255 + "," + 1 + ")";
    this.rgbColor1 = "rgba(" + 255 + "," + 0 + "," + 0 + "," + 1 + ")";
    this.rgbColor2 = "rgba(" + 0 + "," + 0 + "," + 255 + "," + 1 + ")";
    this.rorx = 0;
    this.rory = 0;
    this.satp = "100";
    this.selectedElement = false;
    this.selectedMyElement = null;
    this.shadeart = "";
    this.shader1 = false;
    this.shaderpercent = 1;
    this.shapeArray = [];
    this.shapecode = "<>";
    this.shapeData = "";
    this.shapeID = "moon";
    this.showcurve = "";
    this.showData = "";
    this.showtom0 = false;
    this.showPalette = false;
    this.skax = 0;
    this.skay = 0;
    this.slideAlpha = false;
    this.slidebackground = false;
    this.slideFreeze = false;
    this.slideHorizontal = false;
    this.slideHue = false;
    this.slideLayers = false;
    this.slideRotate = false;
    this.slideSat = false;
    this.slideScale = false;
    this.slideScaleX = false;
    this.slideScaleY = false;
    this.slideSkewX = false;
    this.slideSkewY = false;
    this.slideSpread = false;
    this.slideStrokeColor = false;
    this.slideStrokeWidth = false;
    this.slideVal = false;
    this.slideVertical = false;
    this.slideZoom = false;
    this.squareif = 'SQUARE';
    this.sskax = 0;
    this.sskay = 0;
    this.stageHalf = -250;
    this.stageSize = 400;
    this.startaddress = '<image width="200" height="100" xlink: href="';
    this.startX = 0;
    this.startY = 0;
    this.stopcolor1 = "red";
    this.stopcolor2 = "yellow";
    this.stopcolor3 = "green";
    this.stopcolor4 = "blue";
    this.stopmyarray = true;
    this.stopmyslide = true;
    this.strokeAlpha = 1;
    this.strokeHue = 0;
    this.strokeSat = 100;
    this.strokeVal = 100;
    this.svg = null;
    this.svgheight = 'height="1000px"';
    this.svgstage = "";
    this.svgviewbox = 'viewBox="-400 -400 1000 1000"';
    this.svgwidtth = 'width="400px"';
    this.svgx = 'x="-400px"';
    this.svgy = 'y="-400px"';
    this.th = -this.stageSize;
    this.thing = "";
    this.tom = -1;
    this.tooltipsEnabled = false;
    this.transform = null;
    this.tskax = 0;
    this.tv = -this.stageSize;
    this.typetextString = "";
    this.useArtObjectsbox = false;
    this.usecontainersbox = false;
    this.useGradient2 = false;
    this.usepalettebox = false;
    this.usePaletteNormal = false;
    this.usePaletteplayground = false;
    this.usePaletteShade = false;
    this.usePastePaletteNormal = false;
    this.usePastePalettePlayground = false;
    this.usePastePaletteShade = false;
    this.usepresetsbox = false;
    this.useShadePalette = false;
    this.useShadePlayground = false;
    this.useToolTips = false;
    this.valp = "100";
    this.zoomflag = 0;
  }

  //////////////////////////
/*
  private polyit(event) {
    this.gendx = -200;
    this.gendy = 50;
    var myx = event.clientX;
    var myy = event.clientY;
    myx = myx - 675;
    myy = myy - 305;
    this.polyshape = document.getElementById("polyshape").innerHTML;
    this.polyshape = this.polyshape.replace(
      /"><\/polygon>/,
      myx + "," + myy + ' "></polygon>'
    );
    document.getElementById("polyshape").innerHTML = this.polyshape;
    this.shapeName = "#polyshape";
    document.getElementById("playground").innerHTML = this.polyshape;
    // this.setShape('#playground');
    // this.showData = this.playground;
    // this.playground1 = true;
  }
*/
  //////////////////////////

 private resetSliderToZero(property: keyof CanvasComponent): void {
    if (property in this) {
      (this as any)[property] = 0;
    }
  }

  private resetSliderToValue(property: keyof CanvasComponent, value: number): void {
    if (property in this) {
      (this as any)[property] = value;
    }
  }

  //////////////////////////
private scrollToElement(elementId: string, flagProperty?: string) {
  document.getElementById(elementId).scrollIntoView({ behavior: "auto" });
  if (flagProperty) {
    this[flagProperty] = true;
  }
}
  //////////////////////////

  private checkcolor(hue, sat, val, alpha) {
    if (isNaN(hue) || hue === undefined || hue === null) {
      hue = 10;
    }
    if (isNaN(sat) || sat === undefined || sat === null) {
      sat = 100;
    }
    if (isNaN(val) || val === undefined || val === null) {
      val = 100;
    }
    if (isNaN(alpha) || alpha === undefined || alpha === null) {
      alpha = 1;
    }
    this.currentColor = hue + "," + sat + "," + val + "," + alpha;
    return this.currentColor;
  }

  //////////////////////////

  //////////////////////////

  private shaderShape(rgbColor1: string, rgbColor2: string, shapeId: string) {
    const gradientId = `shader-${shapeId}`;
    const shader = `
<linearGradient id="${gradientId}" x1="0%" y1="0%" x2="0%" y2="100%">
<stop offset="0%" style="stop-color: ${rgbColor1};"></stop>
<stop offset="100%" style="stop-color: ${rgbColor2};"></stop>
</linearGradient>
`;
    // Append to the SVG's defs section
    const defs = document.querySelector("svg defs");
    if (defs) {
      defs.innerHTML += shader;
    } else {
      console.error("SVG does not contain a <defs> section.");
    }
    return `url(#${gradientId})`;
  }

  //////////////////////////

  //////////////////////////

  private openplayground() {
    this.shapeName = "#playground";
    this.shapeID = this.setShape(this.shapeName);
  }

  //////////////////////////

  //////////////////////////

  private buildshader(rgbColor1, rgbColor2) {
    this.stopcolor1 = rgbColor1;
    this.stopcolor2 = rgbColor2;
    this.myshader =
      ` <linearGradient id="newshader" x1="0%" y1="0%" x2="0%" y2="` +
      this.shaderpercent +
      `" > 
<stop offset="0%" style="stop-color: ${this.stopcolor1};">
</stop>
<stop offset="100%" style="stop-color: ${this.stopcolor2};" >
</stop>
</linearGradient > `;

    this.shadercode = document.getElementById("myShade");
    this.shadercode.innerHTML = this.myshader;
    this.shadeFill = "url(#newshader)";
    return this.shadeFill;
  }

  //////////////////////////

  //////////////////////////

  private buildshader2(rgbColor3, rgbColor4) {
    this.stopcolor3 = rgbColor3;
    this.stopcolor4 = rgbColor4;
    this.myshader2 =
      ` <linearGradient id="newshader2" x1="0%" y1="0%" x2="0%" y2="` +
      this.shaderpercent +
      `" > 
<stop offset="0%" style="stop-color: ${this.stopcolor3};">
</stop>
<stop offset="100%" style="stop-color: ${this.stopcolor4};" >
</stop>
</linearGradient > `;

    this.shadercode = document.getElementById("myShadeback");
    this.shadercode.innerHTML = this.myshader2;
    this.shadeFill2 = "url(#newshader2)";

    //const player = document.getElementById("baxter");
    //player.setAttribute("fill", this.shadeFill2);
    return this.shadeFill2;
  }

  //////////////////////////

  //////////////////////////

  private convertStageSize(stageSize) {
    stageSize = Number(stageSize);
    this.stageHalf = Number(stageSize / 2);
    this.svgx = ' x="' + this.stageHalf + ' px "';
    this.svgy = ' y="' + this.stageHalf + ' px "';
    this.svgwidtth = ' width="' + this.stageSize + ' px "';
    this.svgheight = ' height="' + this.stageSize + ' px "';
    this.svgviewbox =
      ' viewBox="' +
      this.stageHalf +
      " " +
      this.stageHalf +
      " " +
      stageSize +
      " " +
      stageSize +
      '"';
    this.svgstage =
      '<svg id="playspace" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"' +
      this.svgx +
      this.svgy +
      this.svgwidtth +
      this.svgheight +
      this.svgviewbox +
      ">";
    var line = document.getElementById("playspace");
    this.svgx = ' x="' + this.stageHalf + ' px "';
    this.svgy = ' y="' + this.stageHalf + ' px "';
    line.setAttribute("width", String(this.stageSize));
    line.setAttribute("height", String(this.stageSize));
    line.setAttribute(
      "viewbox",
      "" +
        this.stageHalf +
        " " +
        this.stageHalf +
        " " +
        stageSize +
        " " +
        stageSize +
        ""
    );
    return this.svgstage;
  }

  //////////////////////////

  //////////////////////////

  private getfactors() {
    this.factors = [
      "arrayBar",
      "Spread",
      "Zoom",
      "Layers",
      "Rotate",
      "Scale",
      "SkewX",
      "SkewY",
      "Horizontal",
      "Vertical",
      "Hue",
      "Sat",
      "Val",
      "Alpha",
      "StrokeColor",
      "StrokeWidth",
      "BackgroundColor",
      "Container"
    ];
    return this.factors;
  }

  //////////////////////////

  //////////////////////////

  private getmyshape() {
    this.myshapelist = [
      "#ABAN",
      "#ABEDUA2",
      "#ADINKRAHENE",
      "#Adinkrahene2",
      "#ADWO",
      "#AKOBEN",
      "#AKOKONAN",
      "#AKOMA",
      "#AKOMANTOASO",
      "#ANANSE-NTONTAN",
      "#angle",
      "#arrow",
      "#arrowbox",
      "#arrowtri",
      "#axis",
      "#AYA",
      "#base",
      "#BESESAKA",
      "#birdsfeet",
      "#blob",
      "#bug",
      "#castle1",
      "#circle",
      "#circlec",
      "#compass",
      "#cross",
      "#DAMAE",
      "#DENKYEM",
      "#diamondh",
      "#diamondv",
      "#DUAFE",
      "#DWANNINIMMEN",
      "#ellipse",
      "#EPA",
      "#film",
      "#FUNTUMFUNAFU",
      "#greek",
      "#grid",
      "#GYENYAME",
      "#heart",
      "#hexagon",
      "#HWEHWEMUDUA",
      "#icon101",
      "#icon102",
      "#icon103",
      "#icon104",
      "#icon105",
      "#icon107",
      "#icon108",
      "#icon109",
      "#icon111",
      "#icon112",
      "#icon113",
      "#icon116",
      "#KURONTINEAKWAMU",
      "#leaves",
      "#lightning",
      "#MAKO",
      "#MENSOWOKENTEN",
      "#MFRAMADAN",
      "#MMEREDANE",
      "#moon",
      "#MPATAPO",
      "#MPUANNUM",
      "#NEAONNIM",
      "#newshape",
      "#NKONSONKONSON",
      "#NKYINKYIM",
      "#NSAA",
      "#NSOROMMA",
      "#NTEASEE",
      "#NYAMEDUA",
      "#NYAMENWUNAMAWU",
      "#octagon",
      "#ODONYERAFIEKWAN",
      "#OKUAFOPA",
      "#OSRAMNENSOROMMA",
      "#OWUOATWEDEE",
      "#pentagon",
      "#petal",
      "#pointer",
      "#pyramid",
      "#roman",
      "#SANKOFA",
      "#SANKOFA2",
      "#scribble",
      "#SEPOW",
      "#SEVEN",
      "#shapeart",
      "#square",
      "#star",
      "#stick",
      "#sun",
      "#TAMFOBEBRE",
      "#triangle",
      "#UACNKANEA",
      "#WAWAABA",
      "#WOFORODUAPAA"
    ];
    return this.myshapelist;
  }

  //////////////////////////

  //////////////////////////

  private getRandom(min, max) {
    var mynum = Math.random() * (max - min) + min;
    mynum = Math.floor(mynum);
    return mynum;
  }

  //////////////////////////
private hsv2rgba(h: number, s: number, v: number, a: number): string {
  s /= 100;
  v /= 100;

  let c = v * s;
  let x = c * (1 - Math.abs((h / 60) % 2 - 1));
  let m = v - c;

    let r = 0,
      g = 0,
      b = 0;

    if (0 <= h && h < 60) [r, g, b] = [c, x, 0];
    else if (60 <= h && h < 120) [r, g, b] = [x, c, 0];
    else if (120 <= h && h < 180) [r, g, b] = [0, c, x];
    else if (180 <= h && h < 240) [r, g, b] = [0, x, c];
    else if (240 <= h && h < 300) [r, g, b] = [x, 0, c];
    else if (300 <= h && h < 360) [r, g, b] = [c, 0, x];

    r = Math.round((r + m) * 255);
    g = Math.round((g + m) * 255);
    b = Math.round((b + m) * 255);

    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }

  //////////////////////////

  private xhsv2rgba(h, s, v, alpha) {
    var r;
    var g;
    var b;
    var i;
    var f;
    var p;
    var q;
    var t;
    var myflag;
    h = h / 360;
    s = s / 100;
    v = v / 100;
    // ############
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);
    // ##############
    myflag = i % 6;
    // console.log(myflag);
    if (myflag == 0) {
      r = v;
      g = t;
      b = p;
    } else if (myflag == 1) {
      r = q;
      g = v;
      b = p;
    } else if (myflag == 2) {
      r = p;
      g = v;
      b = t;
    } else if (myflag == 3) {
      r = p;
      g = q;
      b = v;
    } else if (myflag == 4) {
      r = t;
      g = p;
      b = v;
    } else if (myflag == 5) {
      r = v;
      g = p;
      b = q;
    }
    r = r * 255;
    g = g * 255;
    b = b * 255;
    r = Math.round(r);
    g = Math.round(g);
    b = Math.round(b);
    this.rgbColor = "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
    return this.rgbColor;
  }

  //////////////////////////

  //////////////////////////

  private hueWithWhite2rgba(otherHue) {
    if (otherHue <= 10) {
      this.strokeSat = 100;
      this.strokeVal = 0;
      this.strokeAlpha = 1;
    } else if (otherHue >= 350) {
      this.strokeSat = 0;
      this.strokeVal = 100;
      this.strokeAlpha = 1;
    } else {
      this.strokeSat = 100;
      this.strokeVal = 100;
      this.strokeAlpha = 1;
    }
    this.strokeColorString = this.hsv2rgba(
      otherHue,
      this.strokeSat,
      this.strokeVal,
      this.strokeAlpha
    );
    return this.strokeColorString;
  }

  //////////////////////////

  //////////////////////////

  //////////////////////////

  //////////////////////////

  private processArtData(artData) {
    this.artData = artData;
    var newArt = this.artData.split("_");
    this.numberShapes = Number(newArt[0]);
    this.spreadsize = Number(newArt[1]);
    this.zoomsize = Number(newArt[2]);
    this.layers = Number(newArt[3]);
    this.rotateValue = Number(newArt[4]);
    this.scale = Number(newArt[5]);
    this.skewXValue = Number(newArt[6]);
    this.skewYValue = Number(newArt[7]);
    this.translateHValue = Number(newArt[8]);
    this.translateVValue = Number(newArt[9]);
    this.hue = Number(newArt[10]);
    this.sat = Number(newArt[11]);
    this.val = Number(newArt[12]);
    this.alpha = Number(newArt[13]);
    this.stroke = Number(newArt[14]);
    this.strokeWidth = Number(newArt[15]);
    this.backg = Number(newArt[16]);
    this.shapeName = String(newArt[17]);
    this.randomRotateValue = (newArt[18] + "").toLowerCase() === "true";
    this.randomScaleValue = (newArt[19] + "").toLowerCase() === "true";
    this.randomSkewXValue = (newArt[20] + "").toLowerCase() === "true";
    this.randomSkewYValue = (newArt[21] + "").toLowerCase() === "true";
    this.randomHValue = (newArt[22] + "").toLowerCase() === "true";
    this.randomVValue = (newArt[23] + "").toLowerCase() === "true";
    this.randomHueValue = (newArt[24] + "").toLowerCase() === "true";
    this.randomSatValue = (newArt[25] + "").toLowerCase() === "true";
    this.randomValValue = (newArt[26] + "").toLowerCase() === "true";
    this.randomAlphaValue = (newArt[27] + "").toLowerCase() === "true";
    this.randomStrokevalue = (newArt[28] + "").toLowerCase() === "true";
    this.randomStrokeWidthValue = (newArt[29] + "").toLowerCase() === "true";
    this.outputartdata(
      "rotate",
      this.r,
      this.randomRotateValue,
      "scale",
      this.scale,
      this.randomScaleValue,
      "skewX",
      this.sx,
      this.randomSkewXValue,
      "skewY",
      this.sy,
      this.randomSkewYValue,
      "translate",
      this.th,
      this.randomHValue,
      this.tv,
      this.randomVValue
    );
  }

  //////////////////////////

  //////////////////////////

  private processsvgobject(artData) {
    artData.replace(/\r\n/, "");
    this.artData = artData;
    this.artData = this.cleanThis(this.artData);
    this.re = /@/;
    if (this.artData.match(this.re)) {
      this.info = this.artData.split("@");
      this.newProject = this.info[0];
      this.thing = this.info[1];
      this.thing = this.cleanThis(this.thing);
    } else {
      this.thing = this.artData;
      this.thing = this.cleanThis(this.thing);
    }
    this.setShape("#basement");
    this.shapeName = "#basement";
    document.getElementById("basement").innerHTML = this.thing;
    this.shapeData = this.thing;
    this.showData = "@" + this.shapeData;
  }

  //////////////////////////

  //////////////////////////

  private cleanThis(thisstring) {
    thisstring.replace(/\r\n/, "");
    return thisstring;
  }

  //////////////////////////

  //////////////////////////

  private mydownload(filename, text) {
    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(text)
    );
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  //////////////////////////

  //////////////////////////

  private saveArtData() {
    this.artData =
      this.numberShapes +
      "_" +
      this.spreadsize +
      "_" +
      this.zoomsize +
      "_" +
      this.layers +
      "_" +
      this.rotateValue +
      "_" +
      this.scale +
      "_" +
      this.skewXValue +
      "_" +
      this.skewYValue +
      "_" +
      this.translateHValue +
      "_" +
      this.translateVValue +
      "_" +
      this.hue +
      "_" +
      this.sat +
      "_" +
      this.val +
      "_" +
      this.alpha +
      "_" +
      this.stroke +
      "_" +
      this.strokeWidth +
      "_" +
      this.backg +
      "_" +
      this.shapeName +
      "_" +
      this.randomRotateValue +
      "_" +
      this.randomScaleValue +
      "_" +
      this.randomSkewXValue +
      "_" +
      this.randomSkewYValue +
      "_" +
      this.randomHValue +
      "_" +
      this.randomVValue +
      "_" +
      this.randomHueValue +
      "_" +
      this.randomSatValue +
      "_" +
      this.randomValValue +
      "_" +
      this.randomAlphaValue +
      "_" +
      this.randomStrokevalue +
      "_" +
      this.randomStrokeWidthValue;
    this.filenameout = this.shapeName + "_artData.txt";
    this.filenameout = this.filenameout.replace(/#/, "");
    this.mydownload([this.filenameout], this.artData);
  }

  //////////////////////////

  //////////////////////////

  private savemypng() {
    var id = this.shapeID;
    var n = Math.floor(Math.random() * (9999 - 1000) + 1000);
    var svg = document.getElementById(id),
      xml = new XMLSerializer().serializeToString(svg),
      data = "data:image/svg+xml;base64," + btoa(xml),
      img = new Image();
    img.setAttribute("src", data);
    img.setAttribute("download", "image.png");
    img.setAttribute("id", "myimage");
    var artplace = document.getElementById("art");
    artplace.appendChild(img);
    var pngoutname = "PNG-" + n + ".png";
    this.mydownload([pngoutname], img);
  }

  //////////////////////////

  //////////////////////////

  private scrollanimationtools() {
    document
      .getElementById("scrollanimationtools")
      .scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////
  //////////////////////////

  private scrollArtControl() {
    document
      .getElementById("artcontrolname")
      .scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////

  //////////////////////////

  private scrollartdata() {
    document
      .getElementById("artdatacontrolname")
      .scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////

  //////////////////////////

  private scrollartobjects() {
    document.getElementById("ArtObjects").scrollIntoView({ behavior: "auto" });
    this.useArtObjectsbox = true;
  }

  //////////////////////////

  //////////////////////////

  private scrollbasement() {
    document.getElementById("backlot").scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////

  //////////////////////////

  private scrollbox() {
    document.getElementById("box").scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////

  //////////////////////////

  private scrollcolorsliders() {
    document
      .getElementById("colorsliders")
      .scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////

  //////////////////////////

  private scrollcontainers() {
    document.getElementById("containers").scrollIntoView({ behavior: "auto" });
    this.usecontainersbox = true;
  }

  //////////////////////////

  //////////////////////////

  private scrolldatatool() {
    document.getElementById("datatool").scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////

  //////////////////////////

  private scrolldatatools() {
    document.getElementById("datatools").scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////

  //////////////////////////

  private scrollDown(percentage) {
    var windowHeight = window.innerHeight;
    var scrollHeight = (percentage / 100) * windowHeight;
    window.scrollBy(0, scrollHeight);
  }

  //////////////////////////

  //////////////////////////

  private scrolldrag() {
    document.getElementById("dragcontrol").scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////

  //////////////////////////

  private scrollsquare() {
    this.rotateValue = 0;
    document
      .getElementById("squaretoolsname")
      .scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////

  //////////////////////////

  private scrollgaragecontrol() {
    document
      .getElementById("garagecontrolname")
      .scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////

  //////////////////////////

  private scrollkitchencontrol() {
    document
      .getElementById("kitchencontrolname")
      .scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////

  //////////////////////////

  private scrollmaker() {
    document
      .getElementById("makercontrol")
      .scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////
  private scrolltransformation() {
    document
      .getElementById("transformationname")
      .scrollIntoView({ behavior: "auto" });
  }
  //////////////////////////

  private scrollmoresliders() {
    document.getElementById("moresliders").scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////

  //////////////////////////

  //////////////////////////

  //////////////////////////

  //////////////////////////

  //////////////////////////

  private strokeWithWhite2rgba(stroke) {
    if (this.randomStrokevalue == true) {
      stroke = this.getRandom(10, 360);
    }
    if (stroke <= 1) {
      this.strokeSat = 100;
      this.strokeVal = 0;
      this.strokeAlpha = 1;
    } else if (stroke >= 359) {
      this.strokeSat = 0;
      this.strokeVal = 100;
      this.strokeAlpha = 1;
    } else {
      this.strokeSat = 100;
      this.strokeVal = 100;
      this.strokeAlpha = 1;
    }
    this.strokeColorString = this.hsv2rgba(
      stroke,
      this.strokeSat,
      this.strokeVal,
      this.strokeAlpha
    );
    return this.strokeColorString;
  }

  //////////////////////////

  //////////////////////////

  //////////////////////////

  private toggleTooltips() {
    const clickittextElements = Array.from(
      document.querySelectorAll(".clickittext")
    );
    if (this.tooltipsEnabled) {
      clickittextElements.forEach(element => {
        element.classList.add("hidden");
      });
      this.tooltipsEnabled = false;
    } else if (this.tooltipsEnabled == false) {
      clickittextElements.forEach(element => {
        element.classList.remove("hidden");
      });
      this.tooltipsEnabled = true;
    } else {
      clickittextElements.forEach(element => {
        element.classList.add("hidden");
      });
      this.tooltipsEnabled = true;
    }
  }

  //////////////////////////

  private scrollnodrag() {
    document
      .getElementById("nodragcontrol")
      .scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////

  //////////////////////////

  private scrollPalette() {
    document
      .getElementById("colorpaletteblock")
      .scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////

  //////////////////////////

  private scrollpaletteplacement() {
    document
      .getElementById("paletteplacement")
      .scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////

  //////////////////////////

  private scrollplacement() {
    document.getElementById("placement").scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////

  //////////////////////////

  private scrollplaces() {
    document
      .getElementById("placescontrol")
      .scrollIntoView({ behavior: "auto" });
  }

  //////////////////////////

  //////////////////////////

  private scrollpresets() {
    document.getElementById("presets").scrollIntoView({ behavior: "auto" });
    this.usepresetsbox = true;
  }

  //////////////////////////

  //////////////////////////

  private scrollprimitives() {
    document
      .getElementById("primitivename")
      .scrollIntoView({ behavior: "auto" });
    this.usecontainersbox = true;
  }

  //////////////////////////

  //////////////////////////

  //////////////////////////

  private xaddColor(selectedColor) {
    // console.log("selectedColor", selectedColor);
    selectedColor.a = this.alpha;
    if (this.pastePaletteString) {
      this.paletteString = this.pastePaletteString; // console.log("paletteString", this.paletteString);
    } else {
      if (this.paletteString === "") {
        this.paletteString +=
          selectedColor.h +
          "," +
          selectedColor.s +
          "," +
          selectedColor.b +
          "," +
          selectedColor.a;
      } else {
        this.paletteString =
          this.paletteString +
          " " +
          selectedColor.h +
          "," +
          selectedColor.s +
          "," +
          selectedColor.b +
          "," +
          selectedColor.a;
      }
    } // return this.paletteString;
    this.useColor(this.paletteString);
    if (this.usepalettebox == true) {
      selectedColor.a = this.alpha;
      this.rgbColor = this.nextColor(
        selectedColor.h,
        selectedColor.s,
        selectedColor.b,
        selectedColor.a
      );
      this.pastePaletteString = "";

      return this.rgbColor;
    }
  }

  //////////////////////////
  private useColor(paletteString) {
    var i = 0;
    this.colorString = paletteString.split(" ");
    this.plength = this.colorString.length;
    for (i = 0; i < this.plength; i++) {
      var part = this.colorString[i].split(",");
      var hue = Number(part[0]);
      var sat = Number(part[1]);
      var val = Number(part[2]);
      this.colors[i] = hue + "," + sat + "," + val + "," + this.alpha;
    }
  }

  //////////////////////////

  private addPaletteColor(selectedColor) {
    this.showPalette = !this.showPalette;
    selectedColor.a = this.alpha;
    this.shader1 = false;
    if (this.pastePaletteString) {
      this.paletteString = this.pastePaletteString;
    } else {
      if (this.paletteString === "") {
        this.paletteString +=
          selectedColor.h +
          "," +
          selectedColor.s +
          "," +
          selectedColor.b +
          "," +
          selectedColor.a;
      } else {
        this.paletteString =
          this.paletteString +
          " " +
          selectedColor.h +
          "," +
          selectedColor.s +
          "," +
          selectedColor.b +
          "," +
          selectedColor.a;
      }
    }
    this.useColor(this.paletteString);
    if (this.usepalettebox == true) {
      selectedColor.a = this.alpha;
      this.rgbColor = this.nextColor(
        selectedColor.h,
        selectedColor.s,
        selectedColor.b,
        selectedColor.a
      );
      this.pastePaletteString = "";
      return this.rgbColor;
    }
  }

  //////////////////////////

  //////////////////////////

  private nextColor(hue, sat, val, alpha, paletteIndex?) {
    this.colorString = this.paletteString.split(" ");
    this.plength = this.colorString.length;

    if (!this.colors || this.plength === 0) {
      return this.hsv2rgba(hue, sat, val, alpha);
    }

    if (this.randomColor == true) {
      const stableKey =
        (this.shapeName || "") +
        "|" +
        (typeof paletteIndex === "number" ? paletteIndex : this.counter) +
        "|" +
        this.paletteString;
      this.colorNumber = this.getStableRandom(0, Math.max(this.plength - 1, 0), stableKey);
    } else {
      const currentIndex = typeof paletteIndex === "number" ? paletteIndex : this.counter;
      this.colorNumber = currentIndex % this.plength;
    }
    var part = this.colors[this.colorNumber].split(",");
    hue = Number(part[0]);
    sat = Number(part[1]);
    val = Number(part[2]);
    alpha = Number(part[3]);
    this.rgbColor = this.hsv2rgba(hue, sat, val, alpha);
    return this.rgbColor;
  }
  //////////////////////////

  //////////////////////////

  private arraybar() {
    this.numberShapes += 1;
    if (this.numberShapes > 6) {
      this.numberShapes = 1;
    }
  }

  //////////////////////////

  //////////////////////////

  private assigncolorshapes(selectedColor) {
    var hue = selectedColor.h;
    var sat = selectedColor.s;
    var val = selectedColor.b;
    var alpha = this.alpha;
    this.currentColor = this.checkcolor(hue, sat, val, alpha);
    this.rgbColor1 = this.hsv2rgba(this.shade1, sat, val, alpha);
    this.rgbColor2 = this.hsv2rgba(this.shade2, sat, val, alpha);
    this.shadeFill = this.buildshader(this.rgbColor1, this.rgbColor2);
    this.shapeID = this.setShape(this.shapeName);
    const lightningGroup = document.getElementById(this.shapeID);
    const svgNamespace = "http://www.w3.org/2000 / svg ";
    const player = document.createElementNS(svgNamespace, "g");
    const nid = this.getRandom(100, 200);
    const newid = nid.toString();
    const idname = "#player" + newid;
    player.setAttribute("fill", this.shadeFill);
    player.setAttribute("id", idname);
    while (lightningGroup.firstChild) {
      player.appendChild(lightningGroup.firstChild);
    }
    const shape = document.getElementById("garage");
    shape.appendChild(player);
    this.shapeName = "#garage";
    this.shapeID = this.setShape(this.shapeName);
    this.showData = document.getElementById("garage").innerHTML;
    this.buildplayground();
    document.getElementById("garage").innerHTML = "";
  }
  //////////////////////////

  //////////////////////////

  private assignshadertoshapes(selectedColor: {
    h: number;
    s: number;
    b: number;
  }) {
    this.shader1 = false;
    const hue = selectedColor.h;
    const sat = selectedColor.s;
    const val = selectedColor.b;
    const alpha = this.alpha;

    // Generate two shades for the gradient
    const rgbColor1 = this.hsv2rgba(hue, sat, val, alpha);
    const rgbColor2 = this.hsv2rgba(hue, sat * 0.8, val * 1.2, alpha);

    this.shapeID = this.setShape(this.shapeName);
    const lightningGroup = document.getElementById(this.shapeID);
    if (!lightningGroup) {
      console.error(`Shape with ID ${this.shapeID} not found.`);
      return;
    }

    const svgNamespace = "http://www.w3.org/2000/svg";
    const player = document.createElementNS(svgNamespace, "g");
    const nid = this.getRandom(1, 100);
    const newid = nid.toString();
    const idname = `player-${newid}`;
    player.setAttribute("id", idname);

    // Assign a unique shader to this shape
    const uniqueShader = this.shaderShape(rgbColor1, rgbColor2, idname);
    player.setAttribute("fill", uniqueShader);

    while (lightningGroup.firstChild) {
      player.appendChild(lightningGroup.firstChild);
    }

    const shape = document.getElementById("garage");
    if (shape) {
      shape.appendChild(player);
    } else {
      console.error("Garage element not found.");
    }

    this.shapeName = "#garage";
    this.shapeID = this.setShape(this.shapeName);
    const garageElement = document.getElementById("garage");
    if (garageElement) {
      this.showData = garageElement.innerHTML;
    } else {
      console.error("Garage element not found.");
      this.showData = "";
    }
    this.buildplayground();
    document.getElementById("garage").innerHTML = "";
  }

  //////////////////////////

  //////////////////////////

  //////////////////////////

  //////////////////////////

  //////////////////////////

  private backgWithWhite2rgba(backgHue) {
    if (backgHue <= 10) {
      this.backgSat = 100;
      this.backgVal = 0;
      this.backgAlpha = 1;
    } else if (backgHue >= 350) {
      this.backgSat = 0;
      this.backgVal = 100;
      this.backgAlpha = 1;
    } else {
      this.backgSat = 100;
      this.backgVal = 100;
      this.backgAlpha = 1;
    }
    this.backgColorString = this.hsv2rgba(
      backgHue,
      this.backgSat,
      this.backgVal,
      this.backgAlpha
    );
    return this.backgColorString;
  }
  //////////////////////////

  //////////////////////////

  private art1000() {
    this.stageSize = 1000;
  }

  //////////////////////////
  private art1080() {
    this.stageSize = 1080;
  }
  //////////////////////////

  private bigart() {
    this.stageSize = 5000;
  }

  //////////////////////////

  //////////////////////////

  private breakstring() {
    this.mypalette = this.paletteString;
    this.mypalette = this.mypalette.replace(/\s+/g, "\n");
    return this.mypalette;
  }

  //////////////////////////

  //////////////////////////
  //////////////////////////

  private clearcollection() {
    document.getElementById("collection").innerHTML = "";
  }

  //////////////////////////

  //////////////////////////

  private cleartopart() {
    var artplace = document.getElementById("art");
    var child = artplace.firstElementChild;
    artplace.removeChild(child);
  }

  //////////////////////////

  //////////////////////////

  private buildcollection() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.collection = document.getElementById("collection").innerHTML;
    this.collection = this.collection + this.newbase;
    document.getElementById("collection").innerHTML = this.collection;
    this.shapeName = "#collection";
    this.shapeID = this.setShape(this.shapeName);
    this.showData = this.collection;
    this.setShape("#collection");
  }

  //////////////////////////

  //////////////////////////

  private buildGarage() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.garage = document.getElementById("garage").innerHTML;
    this.garage = this.garage + this.newbase;
    document.getElementById("garage").innerHTML = this.garage;
    this.setShape("#garage");
    this.showData = this.garage;
    this.garage1 = true;
    this.shapeName = "#garage";
    this.shapeID = this.setShape(this.shapeName);
    this.showData = this.garage;
    return this.garage;
  }

  //////////////////////////

  //////////////////////////

  private buildkitchen() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.kitchen = document.getElementById("kitchen").innerHTML;
    this.kitchen = this.kitchen + this.newbase;
    document.getElementById("kitchen").innerHTML = this.kitchen;
    this.kitchen1 = true;
    this.shapeName = "#kitchen";
    this.shapeID = this.setShape(this.shapeName);
    this.showData = this.kitchen;
    return this.kitchen;
  }

  //////////////////////////
  private xbuildplayground() {
                this.shapeID = this.setShape(this.shapeName);
                this.newbase = document.getElementById(this.shapeID).innerHTML;
                this.playground = document.getElementById("playground").innerHTML;
                this.playground = this.newbase + this.playground;
                document.getElementById("playground").innerHTML = this.playground;
                this.setShape('#playground');
                this.showData = this.playground;
                this.playground1 = true;
                this.setShape('#playground');
            }
  //////////////////////////

  private buildplayground() {
    // Get the current shape from the library
    const sourceShapeName = this.shapeName;
    this.shapeID = this.setShape(sourceShapeName);
    const playgroundElement = document.getElementById("playground");
    const shapeElement = document.getElementById(this.shapeID);
    
    if (shapeElement && playgroundElement) {
      // Get the innerHTML from the shape library
      const shapeContent = shapeElement.innerHTML;
      
      // Wrap it in a group with draggable class
      const newGroup = document.createElementNS("http://www.w3.org/2000/svg", "g") as SVGGElement;
      newGroup.setAttribute("class", "draggable playground-shape");
      this.ensurePlaygroundShapeIdentity(newGroup);
      newGroup.innerHTML = shapeContent;
      const dataset = this.getSvgDataset(newGroup);
      if (dataset) {
        dataset.initialTranslateX = '0';
        dataset.initialTranslateY = '0';
      } else {
        newGroup.setAttribute('data-initial-translate-x', '0');
        newGroup.setAttribute('data-initial-translate-y', '0');
      }
      
      // Append to playground
      playgroundElement.appendChild(newGroup);
      this.ensureInitialTranslationMetadata(newGroup, 0, 0);

      // Center only the newly added shape; keep existing playground shapes in place
      this.centerPlaygroundShapePrecisely(newGroup);

      // Treat newly added shape as the active selection target
      this.activeSelection = [newGroup];
      this.selectedShape = newGroup;
      this.selectedPlaygroundShapeId =
        newGroup.getAttribute('data-playground-shape-id') || newGroup.id || '';
      this.selectedPlaygroundTarget = 'selected';

      if (this.selectionBoundingBoxUpdater) {
        setTimeout(() => {
          if (this.selectionBoundingBoxUpdater) {
            this.selectionBoundingBoxUpdater();
          }
        }, 10);
      }
    }

    // Keep playground data visible and switch current stage shape to #playground
    this.showData = playgroundElement ? playgroundElement.innerHTML : "";
    this.playground1 = true;
    this.shapeName = '#playground';
    this.shapeID = this.setShape(this.shapeName);

    setTimeout(() => {
      this.centerStage();
    }, 0);
  }

  //////////////////////////

  //////////////////////////

  private clearall() {
    this.default = 7;
    this.irotate = 0;
    this.iscaleX = 1;
    this.iscaleY = 1;
    this.iscale = 1;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
  }

  //////////////////////////

  //////////////////////////

  private clearartarea() {
    var artplace = document.getElementById("art");
    var child = artplace.lastElementChild;
    while (child) {
      artplace.removeChild(child);
      child = artplace.lastElementChild;
    }
  }

  //////////////////////////

  //////////////////////////

  private clearbasement() {
    document.getElementById("basement").innerHTML = "";
  }

  //////////////////////////

  //////////////////////////

  private cleargarage() {
    document.getElementById("garage").innerHTML = "";
  }

  //////////////////////////

  //////////////////////////

  private clearkitchen() {
    document.getElementById("kitchen").innerHTML = "";
  }

  //////////////////////////

  //////////////////////////

  private clearplayground() {
    document.getElementById("playground").innerHTML = "";
    this.activeSelection = [];
    this.selectedShape = null;
    this.selectedPlaygroundShapeId = '';
  }

  //////////////////////////
  private defaults() {
    if (this.default == 1) {
      this.irotate = 45;
      this.iscale = 3;
      this.iscaleX = 0.8;
      this.iscaleY = 0.8;
      this.iskewX = 30;
      this.iskewY = 30;
      this.imoveh = 0;
      this.imovev = 100;
      this.default = 2;
      //this.lockscale = true;
    } else if (this.default == 2) {
      this.irotate = 90;
      this.iscaleX = -1;
      this.iscaleY = -1;
      this.iscale = -0.8;
      this.iskewX = -20;
      this.iskewY = -20;
      this.imoveh = -20;
      this.imovev = -20;
      this.default = 3;
      //this.lockscale = false;
    } else if (this.default == 3) {
      this.irotate = 360;
      this.iscaleX = 4;
      this.iscaleY = 4;
      this.iscale = 5;
      this.iskewX = 60;
      this.iskewY = 60;
      this.imoveh = 20;
      this.imovev = 20;
      this.default = 4;
      //this.lockscale = true;
    } else if (this.default == 4) {
      this.irotate = 180;
      this.iscaleX = 2;
      this.iscaleY = -5;
      this.iscale = 1;
      this.iskewX = 20;
      this.iskewY = 20;
      this.imoveh = 20;
      this.imovev = 20;
      this.default = 5;
      //this.lockscale = true;
    } else if (this.default == 5) {
      this.irotate = 60;
      this.iscaleX = 1.5;
      this.iscaleY = 1.5;
      this.iscale = 0.7;
      this.iskewX = 30;
      this.iskewY = 30;
      this.imoveh = 20;
      this.imovev = 20;
      this.default = 6;
      //this.lockscale = false;
    } else if (this.default == 6) {
      this.irotate = 0;
      this.iscaleX = 1;
      this.iscaleY = 1;
      this.iscale = 1;
      this.iskewX = 0;
      this.iskewY = 0;
      this.imoveh = 0;
      this.imovev = 0;
      this.default = 7;
      this.lockscale = true;
    } else if (this.default == 7) {
      this.irotate = -60;
      this.iscaleX = -1.5;
      this.iscaleY = -1.5;
      this.iscale = -3;
      this.iskewX = -10;
      this.iskewY = -10;
      this.imoveh = -200;
      this.imovev = -200;
      this.default = 1;
      //this.lockscale = false;
    }
    this.processprimitive();
  }

  private selectShapeTarget() {
    this.selectedPlaygroundTarget = 'selected';
  }

  private selectGroupTarget() {
    this.selectedPlaygroundTarget = 'group';
  }

  private selectAllTarget() {
    this.applyAllPlaygroundSelection(false);
  }

  private selectGroupAllTarget() {
    this.applyAllPlaygroundSelection(true);
  }

  private applyAllPlaygroundSelection(asGroupedObject: boolean) {
    const playground = document.getElementById('playground');
    if (!playground) {
      return;
    }

    this.assignPlaygroundShapeIds();

    const allTargets = Array.from(playground.querySelectorAll('[data-playground-shape-id]')).filter(
      (element): element is SVGGraphicsElement => element instanceof SVGGraphicsElement
    );

    this.selectedPlaygroundTarget = asGroupedObject ? 'group' : 'all';

    if (this.playgroundSelectionApplier) {
      this.playgroundSelectionApplier(allTargets, asGroupedObject);
      return;
    }

    this.activeSelection = allTargets;

    if (allTargets.length > 0) {
      this.selectedShape = allTargets[0];
      this.selectedPlaygroundShapeId = allTargets[0].getAttribute('data-playground-shape-id') || allTargets[0].id || '';
    } else {
      this.selectedShape = null;
      this.selectedPlaygroundShapeId = '';
    }

    if (asGroupedObject && this.selectionBoundingBoxUpdater) {
      setTimeout(() => {
        if (this.selectionBoundingBoxUpdater) {
          this.selectionBoundingBoxUpdater();
        }
      }, 10);
    }
  }

  private pgMoveitH() {
    this.applyPlaygroundOperation(0, 1, 1, 1, 0, 0, this.imoveh, 0);
  }

  private pgMoveitV() {
    this.applyPlaygroundOperation(0, 1, 1, 1, 0, 0, 0, this.imovev);
  }

  private pgRotateit() {
    this.applyPlaygroundOperation(this.irotate, 1, 1, 1, 0, 0, 0, 0);
  }

  private pgScaleit() {
    this.applyPlaygroundOperation(0, this.iscale, 1, 1, 0, 0, 0, 0);
  }

  private pgScaleitX() {
    this.applyPlaygroundOperation(0, 1, this.iscaleX, 1, 0, 0, 0, 0);
  }

  private pgScaleitY() {
    this.applyPlaygroundOperation(0, 1, 1, this.iscaleY, 0, 0, 0, 0);
  }

  private pgSkewitX() {
    this.applyPlaygroundOperation(0, 1, 1, 1, this.iskewX, 0, 0, 0);
  }

  private pgSkewitY() {
    this.applyPlaygroundOperation(0, 1, 1, 1, 0, this.iskewY, 0, 0);
  }

  private applyTransformToSelection() {
    this.selectedPlaygroundTarget = 'selected';
    this.playgroundAnimationMode = false;
    this.doit();
  }

  private applyTransformToGroup() {
    this.selectedPlaygroundTarget = 'group';
    this.playgroundAnimationMode = false;
    this.doit();
  }

  private applyAnimationToSelection() {
    this.selectedPlaygroundTarget = 'selected';
    this.playgroundAnimationMode = true;
    this.doit();
  }

  private applyAnimationToGroup() {
    this.selectedPlaygroundTarget = 'group';
    this.playgroundAnimationMode = true;
    this.doit();
  }

  private endPlaygroundAnimation() {
    this.selectedPlaygroundTarget = 'all';
    this.playgroundAnimationMode = false;
    this.stopAllPlaygroundAnimations();
  }

  //////////////////////////

  //////////////////////////
  private doit() {
    this.applyPlaygroundOperation(
      this.irotate,
      this.iscale,
      this.iscaleX,
      this.iscaleY,
      this.iskewX,
      this.iskewY,
      this.imoveh,
      this.imovev
    );
  }
  //////////////////////////

  //////////////////////////

  private grabshape() {
    this.myshapelist = this.getmyshape();
    this.shapeName = this.myshapelist[this.getRandom(0, 99)];
  }

  private nextshape() {
    this.shapeName = this.getNextShapeNameFromList(this.shapeName);
  }

  private getNextShapeNameFromList(currentShapeName: string): string {
    this.myshapelist = this.getmyshape();
    if (!this.myshapelist || this.myshapelist.length === 0) {
      return currentShapeName;
    }

    const maxIndex = Math.min(99, this.myshapelist.length - 1);
    const currentIndex = this.myshapelist.indexOf(currentShapeName);
    const boundedCurrentIndex = currentIndex >= 0 && currentIndex <= maxIndex ? currentIndex : -1;
    const nextIndex = boundedCurrentIndex === -1 || boundedCurrentIndex >= maxIndex
      ? 0
      : boundedCurrentIndex + 1;

    return this.myshapelist[nextIndex];
  }

  //////////////////////////

  //////////////////////////

  private makeArtData() {
    this.myshape = this.getmyshape();
    this.factors = this.getfactors();

    this.randomartdata = this.getRandom(1, 6).toString() + "_";
    console.log("arraybar", this.factors[0]);

    this.randomartdata =
      this.randomartdata + this.getRandom(1, 200).toString() + "_";
    console.log("Spread", this.factors[1]);

    this.randomartdata =
      this.randomartdata + this.getRandom(10, 60).toString() + "_";
    console.log("Zoom", this.factors[2]);

    this.randomartdata =
      this.randomartdata + this.getRandom(3, 180).toString() + "_";
    console.log("Layers", this.factors[3]);

    this.randomartdata =
      this.randomartdata + this.getRandom(0, 360).toString() + "_";
    console.log("Rotate", this.factors[4]);

    this.randomartdata =
      this.randomartdata + (this.getRandom(200, 400) / 1000).toString() + "_";
    console.log("Scale", this.factors[5]);

    this.randomartdata =
      this.randomartdata + this.getRandom(0, 50).toString() + "_";
    console.log("SkewX", this.factors[6]);

    this.randomartdata =
      this.randomartdata + this.getRandom(0, 50).toString() + "_";
    console.log("SkewY", this.factors[7]);

    this.randomartdata =
      this.randomartdata + this.getRandom(0, 400).toString() + "_";
    console.log("Horizontal", this.factors[8]);

    this.randomartdata =
      this.randomartdata + this.getRandom(0, 400).toString() + "_";
    console.log("Vertical", this.factors[9]);

    this.randomartdata =
      this.randomartdata + this.getRandom(1, 360).toString() + "_";
    console.log("Hue", this.factors[10]);

    this.randomartdata =
      this.randomartdata + this.getRandom(60, 100).toString() + "_";
    console.log("Sat", this.factors[11]);

    this.randomartdata =
      this.randomartdata + this.getRandom(100, 100).toString() + "_";
    console.log("Val", this.factors[12]);

    this.randomartdata =
      this.randomartdata + this.getRandom(1, 1).toString() + "_";
    console.log("Alpha", this.factors[13]);

    if (this.lockStroke === false) {
      this.randomartdata =
        this.randomartdata + this.getRandom(0, 0).toString() + "_";
    } else if (this.lockStroke === true) {
      this.randomartdata = this.randomartdata + this.stroke.toString() + "_";
    }
    console.log("StrokeColor", this.factors[14]);

    this.randomartdata =
      this.randomartdata + this.getRandom(2, 2).toString() + "_"; //      "StrokeWidth",
    console.log("StrokeWidth", this.factors[15]);

    if (this.lockbackg === false) {
      this.randomartdata =
        this.randomartdata + this.getRandom(0, 360).toString() + "_";
    } else if (this.lockbackg === true) {
      this.randomartdata = this.randomartdata + this.backg.toString() + "_";
    }
    console.log("BackgroundColor", this.factors[16]);

    this.randomartdata =
      this.randomartdata + this.myshapelist[this.getRandom(0, 95)];
    console.log("Container", this.factors[17]);

    if (this.lockshader === false) {
      this.shade1 = this.getRandom(0, 360);
    } else if (this.lockshader === true) {
      this.shade1 = this.shade1;
    }
    if (this.lockshader === false) {
      this.shade2 = this.getRandom(0, 360);
    } else if (this.lockshader === true) {
      this.shade2 = this.shade2;
    }
    this.processArtData(this.randomartdata);
    console.log(this.randomartdata);
  }

  //////////////////////////

  //////////////////////////

  private makeShaderData() {
    this.shade2 = this.getRandom(0, 360);
    this.shade1 = this.getRandom(0, 360);
    while (this.shade1 == this.shade2) {
      this.shade2 = this.getRandom(0, 360);
      this.shade1 = this.getRandom(0, 360);
    }
    return this.shade1, this.shade2;
  }

  //////////////////////////

  //////////////////////////

  private makeBackgData() {
    this.shade3 = this.getRandom(0, 360);
    this.shade4 = this.getRandom(0, 360);
    while (this.shade4 == this.shade3) {
      this.shade3 = this.getRandom(0, 360);
      this.shade4 = this.getRandom(0, 360);
    }
    return this.shade3, this.shade4;
  }

  //////////////////////////

  //////////////////////////

  private newPalette() {
    this.paletteString = "";
    return this.paletteString;
  }

  //////////////////////////

  //////////////////////////

  private normalart() {
    this.stageSize = 400;
    this.scale - 0.03;
  }

  //////////////////////////

  //////////////////////////

  //////////////////////////

  //////////////////////////

  private normalFill(hue, sat, val, alpha, r) {
    const paletteIndex = Number(r) || 0;
    const fillKey =
      (this.shapeName || "") +
      "|" +
      (this.squareif || "") +
      "|" +
      paletteIndex +
      "|" +
      (Number(this.layers) || 0) +
      "|" +
      (Number(this.spreadsize) || 0);

    if (this.randomHueValue == true) {
      hue = this.getStableRandom(0, 360, fillKey + "|hue|" + hue);
    }
    if (this.randomSatValue == true) {
      sat = this.getStableRandom(0, 100, fillKey + "|sat|" + sat);
    }
    if (this.randomValValue == true) {
      val = this.getStableRandom(20, 100, fillKey + "|val|" + val);
    }
    if (this.randomAlphaValue == true) {
      alpha = this.getStableRandom(10, 100, fillKey + "|alpha|" + alpha) / 100;
    }
    if (this.shader1 == true) {
      this.usepalettebox = false;
      this.currentColor = hue + "," + sat + "," + val + "," + alpha;
      this.rgbColor1 = this.hsv2rgba(this.shade1, sat, val, alpha);
      this.rgbColor2 = this.hsv2rgba(this.shade2, sat, val, alpha);
      this.shadeFill = this.buildshader(this.rgbColor1, this.rgbColor2);
      return this.shadeFill;
    } else if (this.shader1 == false) {
      hue = hue % 360;
      this.currentColor = hue + "," + sat + "," + val + "," + alpha;
      this.rgbColor = this.hsv2rgba(hue, sat, val, alpha);
      this.currentFill = this.rgbColor;
      if (this.usepalettebox == true) {
        const originalCounter = this.counter;
        this.counter = paletteIndex;
        this.rgbColor = this.nextColor(hue, sat, val, alpha, paletteIndex);
        this.counter = originalCounter;
      }
      return this.rgbColor;
    }
  }

  //////////////////////////

  //////////////////////////
  private L2() {
    this.layers = Math.sqrt(this.layers);
    this.layers = Math.floor(this.layers);
    this.layers += 1;
    this.layers =1 + this.layers ** 2;
  }
  //////////////////////////

  private oneShape() {
    this.squareif = 'ROUND';
    if (
      this.shapeName == "#kitchen" ||
      this.shapeName == "#polyshape" ||
      this.shapeName == "#garage" ||
      this.shapeName == "#basement"
    ) {
      this.buildplayground();
    }
    this.rememberArtData =
      this.numberShapes +
      "_" +
      this.spreadsize +
      "_" +
      this.zoomsize +
      "_" +
      this.layers +
      "_" +
      this.rotateValue +
      "_" +
      this.scale +
      "_" +
      this.skewXValue +
      "_" +
      this.skewYValue +
      "_" +
      this.translateHValue +
      "_" +
      this.translateVValue +
      "_" +
      this.hue +
      "_" +
      this.sat +
      "_" +
      this.val +
      "_" +
      this.alpha +
      "_" +
      this.stroke +
      "_" +
      this.strokeWidth +
      "_" +
      this.backg +
      "_" +
      this.shapeName +
      "_" +
      this.randomRotateValue +
      "_" +
      this.randomScaleValue +
      "_" +
      this.randomSkewXValue +
      "_" +
      this.randomSkewYValue +
      "_" +
      this.randomHValue +
      "_" +
      this.randomVValue +
      "_" +
      this.randomHueValue +
      "_" +
      this.randomSatValue +
      "_" +
      this.randomValValue +
      "_" +
      this.randomAlphaValue +
      "_" +
      this.randomStrokevalue +
      "_" +
      this.randomStrokeWidthValue;
    if (this.shapeName == "#playground") {
      this.shapeID = this.setShape(this.shapeName);
      this.shapeData = document.getElementById(this.shapeID).innerHTML;
      this.showData = this.shapeData;
      this.rememberArtData = this.rememberArtData + "@" + this.shapeData;
      document.getElementById(
        "rememberartdata"
      ).innerHTML = this.rememberArtData;
    }
    document.getElementById("rememberartdata").innerHTML = this.rememberArtData;
    this.newProject =
      "1_0_60_1_5_2_0_0_0_0_10_100_100_1_0_5_360_" +
      this.shapeName +
      "_false_false_false_false_false_false_false_false_false_false_false_false";
    this.processArtData(this.newProject);
  }

  //////////////////////////

  //////////////////////////

  private outputSpread(
    rotateValue: number,
    spreadsize: number,
    gendx: number,
    gendy: number

  ): string {
  const radians = (rotateValue * Math.PI) / 180;
  const centerX = this.squareif === 'ROUND' ? 0 : gendx;
  const centerY = this.squareif === 'ROUND' ? 0 : gendy;
  const translateX = centerX + spreadsize * Math.cos(radians);
  const translateY = centerY + spreadsize * Math.sin(radians);

    this.outputSpreadString = `rotate(${rotateValue},0,0) scale(1,1) skewX(0) skewY(0) translate(${translateX}, ${translateY})`;

    return this.outputSpreadString;
  }

  //////////////////////////

  //////////////////////////

  private pasteArtData() {
    this.pasteArtDataString = prompt("Paste artData Here:\n");
    this.pasteArtDataString.replace(/\r\n/, "");
    if (this.pasteArtDataString == "") {
      this.pasteArtDataString =
        "3_200_20_168_5_0.23_0_0_0_0_10_100_100_1_0_5_0_#stick_false_false_false_false_false_false_false_false_false_false_false_false";
    }
    this.processArtData(this.pasteArtDataString);
  }

  //////////////////////////

  //////////////////////////

  private pasteimageaddress() {
    this.thing = "";
    this.startaddress =
      '<image class="draggable" width="200" height="100" xlink: href="';
    this.endaddress = '"></image>';
    this.pasteImagecodeString = prompt("Paste image address here");
    this.pasteImagecodeString.replace(/\r\n/, "");
    this.pasteImagecodeString.replace(
      /\/>/,
      'vector-effect="non-scaling-stroke" />'
    );
    this.pasteImagecodeString.replace(
      />/,
      'vector-effect="non-scaling-stroke" >'
    );
    if (this.pasteImagecodeString == "") {
      this.pasteImagecodeString = "assets/images/mathartshaper.jpg";
    }
    this.pasteImagecodeString =
      this.startaddress + this.pasteImagecodeString + this.endaddress;
    this.processsvgobject(this.pasteImagecodeString);
    this.artData =
      "5_86_30_86_0_1.911_0_0_0_0_242_60_100_1_0_0_147_#basement_false_false_false_false_false_false_false_false_false_false_false_false";
    this.processArtData(this.artData);
  }

  //////////////////////////

  //////////////////////////

  private pastePalette() {
    this.shader1 = false;
    this.pastePaletteString = prompt("Add a Palette");
    if (this.pastePaletteString == "") {
      this.pastePaletteString = "356,94,97,1 356,4,99,1 241,92,97,1";
    }
    this.paletteString = this.pastePaletteString;
    this.useColor(this.paletteString);
    return this.rgbColor;
  }

  //////////////////////////

  //////////////////////////

  private pasteplayground() {
    this.thing = "";
    this.pasteSVGcodeString = prompt("Paste SVG for Playground code here");
    this.pasteSVGcodeString.replace(/\r\n/, "");
    this.pasteSVGcodeString.replace(
      /\/>/,
      'vector-effect="non-scaling-stroke" />'
    );
    this.pasteSVGcodeString.replace(
      />/,
      'vector-effect="non-scaling-stroke" >'
    );
    if (this.pasteSVGcodeString == "") {
      this.pasteSVGcodeString =
        '<polygon class="draggable"  fill="#F5DC37" stroke="#000000" stroke-miterlimit="10" points="206.323,570.564 421.252,259.573 255.097,398.838 288.379,403.242 146.364,573.303 273.729,452.972 "></polygon>' +
        '<polygon fill="#3EA1DA" stroke="#000000" stroke-miterlimit="10" points="258.204,603.367 361.429,202.403 253.675,410.341 284.185,401.271 206.188,630.473 285.033,457.382 "></polygon>' +
        '<polygon fill="#40AFCE" stroke="#000000" stroke-miterlimit="10" points="366.662,421.977 104.676,482.109 343.157,326.508 283.908,392.52 469.607,314.571 291.628,419.194 "></polygon>' +
        '<polygon fill="#F5DC37" stroke="#000000" stroke-miterlimit="10" points="339.196,438.413 100.11,420.35 363.922,351.862 285.857,391.91 471.498,374.968 279.88,416.396 "></polygon>' +
        '<polygon fill="#D81869" stroke="#000000" stroke-miterlimit="10" points="316.82,460.423 132.576,317.93 360.932,402.747 287.753,393.85 439.586,479.128 276.079,410.71 "></polygon>' +
        '<polygon fill="#3EA1DA" stroke="#000000" stroke-miterlimit="10" points="292.678,466.197 188.362,247.903 343.676,443.218 288.721,395.614 383.801,549.155 274.772,403.004 "></polygon>' +
        '<polygon fill="#7AC143" stroke="#000000" stroke-miterlimit="10" points="274.893,446.82 230.458,236.854 330.322,465.159 289.398,398.356 341.705,560.205 273.951,394.059 "></polygon>' +
        '<polygon fill="#EE1E42" stroke="#000000" stroke-miterlimit="10" points="264.39,423.334 277.161,243.377 308.658,477.564 289.138,400.297 295.189,552.502 276.6,385.751 "></polygon>';
    }
    this.setShape("#playground");
    this.shapeName = "#playground";
    var contents = document.getElementById("playground").innerHTML;
    this.pasteSVGcodeString += contents;
    document.getElementById("playground").innerHTML = this.pasteSVGcodeString;
    this.shapeData = this.pasteSVGcodeString;
  }

  //////////////////////////

  //////////////////////////

  private pastesvgobject() {
    this.thing = "";
    this.pasteSVGcodeString = prompt("Paste SVG code here");
    this.pasteSVGcodeString.replace(/\r\n/, "");
    this.pasteSVGcodeString.replace(
      /\/>/,
      'vector-effect="non-scaling-stroke" />'
    );
    this.pasteSVGcodeString.replace(
      />/,
      'vector-effect="non-scaling-stroke" >'
    );
    if (this.pasteSVGcodeString == "") {
      this.pasteSVGcodeString =
        '<polygon class="draggable" fill="#F5DC37" stroke="#000000" stroke-miterlimit="10" points="206.323,570.564 421.252,259.573 255.097,398.838 288.379,403.242 146.364,573.303 273.729,452.972 "></polygon>' +
        '<polygon fill="#3EA1DA" stroke="#000000" stroke-miterlimit="10" points="258.204,603.367 361.429,202.403 253.675,410.341 284.185,401.271 206.188,630.473 285.033,457.382 "></polygon>' +
        '<polygon fill="#40AFCE" stroke="#000000" stroke-miterlimit="10" points="366.662,421.977 104.676,482.109 343.157,326.508 283.908,392.52 469.607,314.571 291.628,419.194 "></polygon>' +
        '<polygon fill="#F5DC37" stroke="#000000" stroke-miterlimit="10" points="339.196,438.413 100.11,420.35 363.922,351.862 285.857,391.91 471.498,374.968 279.88,416.396 "></polygon>' +
        '<polygon fill="#D81869" stroke="#000000" stroke-miterlimit="10" points="316.82,460.423 132.576,317.93 360.932,402.747 287.753,393.85 439.586,479.128 276.079,410.71 "></polygon>' +
        '<polygon fill="#3EA1DA" stroke="#000000" stroke-miterlimit="10" points="292.678,466.197 188.362,247.903 343.676,443.218 288.721,395.614 383.801,549.155 274.772,403.004 "></polygon>' +
        '<polygon fill="#7AC143" stroke="#000000" stroke-miterlimit="10" points="274.893,446.82 230.458,236.854 330.322,465.159 289.398,398.356 341.705,560.205 273.951,394.059 "></polygon>' +
        '<polygon fill="#EE1E42" stroke="#000000" stroke-miterlimit="10" points="264.39,423.334 277.161,243.377 308.658,477.564 289.138,400.297 295.189,552.502 276.6,385.751 "></polygon>';
    }
    this.processsvgobject(this.pasteSVGcodeString);
  }

  //////////////////////////

  //////////////////////////

  private prepareart() {
    if (this.shapeName == "#garage") {
      return;
    } else {
      this.cleargarage();
      this.buildGarage();
      return this.garage;
    }
  }

  //////////////////////////

  //////////////////////////

  private recover() {
    const hold = this.shader1;
    this.shader1 = false;
    this.artData = document.getElementById("rememberartdata").innerHTML;
    document.getElementById("rememberartdata").innerHTML = " ";
    this.processArtData(this.artData);
    this.shader1 = hold;
  }

  //////////////////////////

  //////////////////////////

  private downloadArt() {
    this.shapeID = this.setShape(this.shapeName);
    var svg = document.getElementById("playspace");
    var xml = new XMLSerializer().serializeToString(svg);
    var data = "data:image/svg+xml;base64," + btoa(xml);
    var img = new Image();
    img.setAttribute("src", data);
    img.setAttribute("download", "image.svg");
    img.setAttribute("id", "myimage");
    img.src = data;
    var artplace = document.getElementById("art");
    artplace.insertBefore(img, artplace.firstChild);
    this.mysvgfile = String(img);
    this.scrollArtControl();
  }

  //////////////////////////

  ///////////////////////
  private saveArt() {
    var svg = document.getElementById("playspace");
    var xml = new XMLSerializer().serializeToString(svg);
    var data = "data:image/svg+xml;base64," + btoa(xml);
    var img = new Image();
    img.setAttribute("src", data);
    img.setAttribute("download", "image.svg");
    img.setAttribute("id", "myimage");
    //////////////////////////

    //make PNG
    img.onload = () => {
      var canvas = document.createElement("canvas");
      var context = canvas.getContext("2d");
      canvas.width = img.width;
      canvas.height = img.height;
      context.drawImage(img, 0, 0);
      var pngDataUrl = canvas.toDataURL("image/png");
      var link = document.createElement("a");
      link.href = pngDataUrl;
      link.download = "image.png";
      link.click();
    };
    //////////////////////////

    //raster art
    img.src = data;
    var artplace = document.getElementById("art");
    artplace.insertBefore(img, artplace.firstChild);
    this.mysvgfile = String(img);
    this.scrollArtControl();
    this.stageSize = 400;
  }

  //////////////////////////
  private setShape(shapeName) {
    this.shapeName = shapeName;
    this.shapeID = this.shapeName.replace(/#/, "");
    // Center only library symbols (never recenter live playground container)
    if (this.shapeID !== "playground") {
      this.centerLibraryShape(this.shapeID);
    }
    return this.shapeID;
  }

  ///////////////////////


  ///////////////////////
  private saveArtArea() {
    var img = document.getElementById("myimage") as HTMLImageElement;
    if (!img) {
      console.error("Raster image not found in the art area.");
      return;
    }

    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");

    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;

    context.drawImage(img, 0, 0);

    var pngDataUrl = canvas.toDataURL("image/png");
    var link = document.createElement("a");
    link.href = pngDataUrl;
    link.download = "image.png";
    link.click();
  }

  //////////////////////////

  //////////////////////////

  private savePalette() {
    var dataout = this.shadeart + "_palette.txt";
    this.mydownload([dataout], this.paletteString);
    return this.paletteString;
  }

  //////////////////////////

  //////////////////////////

  //////////////////////////

  //////////////////////////

  private savePlaygroundArea() {
    this.squareif = 'SQUARE';
    this.stageSize = 1000;

    var svg = document.getElementById("sandlot");
    var xml = new XMLSerializer().serializeToString(svg);
    var data = "data:image/svg+xml;base64," + btoa(xml);
    var img = new Image();
    img.setAttribute("src", data);
    img.setAttribute("download", "image.svg");
    img.setAttribute("id", "myimage");
    //////////////////////////

    //make PNG
    img.onload = () => {
      var canvas = document.createElement("canvas");
      var context = canvas.getContext("2d");
      canvas.width = img.width;
      canvas.height = img.height;
      context.drawImage(img, 0, 0);
      var pngDataUrl = canvas.toDataURL("image/png");
      var link = document.createElement("a");
      link.href = pngDataUrl;
      link.download = "image.png";
      link.click();
    };
    //////////////////////////

    //raster art
    img.src = data;
    var artplace = document.getElementById("art");
    artplace.insertBefore(img, artplace.firstChild);
    this.mysvgfile = String(img);
    this.scrollArtControl();
    this.stageSize = 400;
  }

  //////////////////////////

  //////////////////////////

  private savesvg() {
    const shapeElement = document.getElementById(this.shapeID);
    if (!shapeElement) {
      return;
    }

    const svgContent =
      '<?xml version="1.0" encoding="UTF-8"?>\n' +
      '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-1000 -1000 2000 2000">\n' +
      shapeElement.outerHTML +
      "\n</svg>\n";
    const outputName = this.shapeID + "_shape.svg";

    const blob = new Blob([svgContent], {
      type: "image/svg+xml;charset=utf-8"
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = outputName;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  //////////////////////////

  //////////////////////////

  private scaleit(iscale) {
    // this.duplicateShape = true;
    this.rememberDefaults();
    this.iscale = iscale;
    this.atype = "scale";
    this.avalues = 0.1 + " " + iscale + " " + 0.1;
    var myset = iscale;
    this.irotate = 0;
    this.iscaleX = iscale;
    this.iscaleY = iscale;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive();
    this.recallDefaults();
    iscale = myset;
  }

  //////////////////////////

  //////////////////////////

  private scaleitX(iscaleX) {
    // this.duplicateShape = true;
    this.rememberDefaults();
    this.iscaleX = iscaleX;
    this.atype = "scale";
    this.avalues =
      1 +
      " " +
      1 +
      " " +
      iscaleX +
      " " +
      1 +
      " " +
      1 +
      " " +
      1 +
      " " +
      -iscaleX +
      " " +
      1 +
      " " +
      1 +
      " " +
      1;
    var myset = iscaleX;
    this.irotate = 0;
    // this.iscaleX = .95;
    this.iscaleY = 1;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive();
    this.recallDefaults();
    iscaleX = myset;
  }

  //////////////////////////

  //////////////////////////

  private scaleitY(iscaleY) {
    // this.duplicateShape = true;
    this.rememberDefaults();
    this.iscaleY = iscaleY;
    this.atype = "scale";
    this.avalues = 1 + " " + 1 + " " + 1 + " " + iscaleY + " " + 1 + " " + 1;
    var myset = iscaleY;
    this.irotate = 0;
    this.iscaleX = 1;
    // this.iscaleY = .9;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive();
    this.recallDefaults();
    iscaleY = myset;
  }

  //////////////////////////

  //////////////////////////

  private showShapeCode() {
    // this.shapeData = "";
    this.shapeName = "#playground";
    this.shapeData = "<html>\n";
    this.shapeData = this.shapeData + '<svg id="playspace" ';
    this.shapeData = this.shapeData + 'version="1.1" ';
    this.shapeData = this.shapeData + 'xmlns="http://www.w3.org/2000/svg" ';
    this.shapeData =
      this.shapeData + 'xmlns:xlink="http://www.w3.org/1999/xlink" ';
    this.shapeData = this.shapeData + 'x="-1000px" y="-1000px " ';
    this.shapeData = this.shapeData + 'width="2000px" height="2000px " ';
    this.shapeData = this.shapeData + 'viewBox="-1000 -1000 2000 2000">\n';
    this.shapeData = this.shapeData + '<g fill = "white" stroke="black" >\n';
    this.shapeData =
      this.shapeData + document.getElementById("playground").innerHTML;
    this.shapeData = this.shapeData + "</g>\n</svg>\n</html>\n";
    return this.shapeData;
  }

  //////////////////////////

  //////////////////////////

  private rememberDefaults() {
    this.modifyit = [
      this.irotate,
      this.iscaleX,
      this.iscaleY,
      this.iscale,
      this.iskewX,
      this.iskewY,
      this.imoveh,
      this.imovev,
      this.default
    ];
    return this.modifyit;
  }

  //////////////////////////

  //////////////////////////

  private processprimitive() {
    var myshape = document.getElementById(this.shapeID);
    var mymirror = myshape.innerHTML;
    var action =
      '<g transform ="' +
      "rotate(" +
      this.irotate +
      "," +
      0 +
      "," +
      0 +
      ") " +
      "scale(" +
      this.iscaleX +
      "," +
      this.iscaleY +
      ") " +
      "skewX(" +
      this.iskewX +
      ") " +
      "skewY(" +
      this.iskewY +
      ") " +
      "translate(" +
      this.imoveh +
      "," +
      this.imovev +
      ')">';
    action = action + mymirror + "</g>";

    // For ROUND mode, only show transformed versions, not the stationary centered shape
    if (this.squareif === 'ROUND') {
      document.getElementById("playground").innerHTML = action;
    } else {
      mymirror = mymirror + action;
      if (this.duplicateShape == true) {
        document.getElementById("playground").innerHTML = mymirror;
      } else if (this.moveShape == true) {
        document.getElementById("playground").innerHTML = action;
      }
    }
    //this.default = 1;
    //this.defaults();
  }

  //////////////////////////

  //////////////////////////

  private recallDefaults() {
    this.irotate = this.modifyit[0];
    this.iscaleX = this.modifyit[1];
    this.iscaleY = this.modifyit[2];
    this.iscale = this.modifyit[3];
    this.iskewX = this.modifyit[4];
    this.iskewY = this.modifyit[5];
    this.imoveh = this.modifyit[6];
    this.imovev = this.modifyit[7];
    this.default = this.modifyit[8];
  }

  //////////////////////////

  //////////////////////////

  private skewitX(iskewX) {
    this.duplicateShape = true;
    this.rememberDefaults();
    this.iskewX = iskewX;
    this.atype = "skewX";
    this.avalues = 0 + ";" + iskewX + ";" + 0 + ";" + -iskewX + ";" + 0;
    var myset = iskewX;
    this.irotate = 0;
    this.iscaleX = 1;
    this.iscaleY = 1;
    // this.iskewX = 20;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive();
    this.recallDefaults();
    this.iskewX = myset;
  }

  //////////////////////////

  //////////////////////////

  private skewitY(iskewY) {
    // this.duplicateShape = true;
    this.rememberDefaults();
    this.iskewY = iskewY;
    this.atype = "skewY";
    this.avalues = 0 + " " + iskewY + " " + 0 + " " + -iskewY + " " + 0;
    var myset = iskewY;
    this.irotate = 0;
    this.iscaleX = 1;
    this.iscaleY = 1;
    this.iskewX = 0;
    // this.iskewY = -30;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive();
    this.recallDefaults();
    this.iskewY = myset;
  }

  //////////////////////////

  //////////////////////////

  private getheader() {
    let svgHeader = `
<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE html>
<html>
<head>
<title>SVG Shapes</title>
</head>
<body>
<svg x="-1000px" y="-1000px" width="${this.stageSize}" height="${
      this.stageSize
    }" viewBox="-1000 -1000 2000 2000"
xmlns="http://www.w3.org/2000/svg">`;
    return svgHeader;
  }

  //////////////////////////

  //////////////////////////

  private getfooter() {
    let svgFooter = `
</svg>
</body>
</html>`;
    return svgFooter;
  }

  //////////////////////////

  //////////////////////////

  private typeintext() {
    this.thing = "";
    this.startaddress = '<text class="draggable" class="mytext" >';
    this.endaddress = "</text>";
    this.typetextString = prompt("Type in text here: ");
    this.typetextString.replace(/\r\n/, "");
    if (this.typetextString == "") {
      this.typetextString = "Mathart.us";
    }
    this.typetextString =
      this.startaddress + this.typetextString + this.endaddress;
    this.processsvgobject(this.typetextString);
    this.artData =
      " 1_50_1_40_14_0.171_0_0_0_0_10_100_100_1_0_0_0_#basement_false_false_false_false_false_false_false_false_false_false_false_false";
    this.processArtData(this.artData);
  }

  //////////////////////////

  //////////////////////////

  private addColor(selectedColor) {
    // console.log("selectedColor", selectedColor);
    selectedColor.a = this.alpha;
    if (this.pastePaletteString) {
      this.paletteString = this.pastePaletteString;
      // console.log("paletteString", this.paletteString);
    } else {
      if (this.paletteString === "") {
        this.paletteString +=
          selectedColor.h +
          "," +
          selectedColor.s +
          "," +
          selectedColor.b +
          "," +
          selectedColor.a;
      } else {
        this.paletteString =
          this.paletteString +
          " " +
          selectedColor.h +
          "," +
          selectedColor.s +
          "," +
          selectedColor.b +
          "," +
          selectedColor.a;
      }
    }
    // return this.paletteString;
    this.useColor(this.paletteString);
    if (this.usepalettebox == true) {
      selectedColor.a = this.alpha;
      this.rgbColor = this.nextColor(
        selectedColor.h,
        selectedColor.s,
        selectedColor.b,
        selectedColor.a
      );
      this.pastePaletteString = "";
      return this.rgbColor;
    }
  }

  //////////////////////////

  //////////////////////////

  private addone(item) {
    this.item = item;
    if (this.item == "Alpha") {
      this.alpha -= 0.1;
    }
    if (this.item == "BackgroundColor") {
      this.backg -= 1;
    }
    if (this.item == "Horizontal") {
      this.translateHValue += 10;
    }
    if (this.item == "Hue") {
      this.hue += 1;
      if (this.hue >= 360) {
        this.hue = 0;
      }
    }
    if (this.item == "hue") {
      this.hue += 1;
      if (this.hue >= 360) {
        this.hue = 0;
      }
    }

    if (this.item == "Layers") {
      this.layers += 1;
    }
    if (this.item == "In") {
      this.zoomsize = this.layers;
      this.scale = 0.003;
    }
    if (this.item == "Out") {
      this.zoomsize = 1;
      this.scale = 0.003;
    }
    if (this.item == "Rotate") {
      this.rotateValue += 1;
    }
    if (this.item == "Sat") {
      this.sat -= 5;
    }
    if (this.item == "Scale") {
      this.scaleX += 0.01;
      this.scaleY += 0.01;
      this.scale += 0.01;
    }
    if (this.item == "SkewX") {
      this.skewXValue += 1;
    }
    if (this.item == "SkewY") {
      this.skewYValue += 1;
    }
    if (this.item == "scaleX") {
      this.scaleX += 0.1;
    }
    if (this.item == "scaleY") {
      this.scaleY += 0.1;
    }
    if (this.item == "Spread") {
      this.spreadsize += 1;
    }
    if (this.item == "StageSize") {
      this.stageSize += 10;
    }
    if (this.item == "StrokeColor") {
      this.stroke += 1;
    }
    if (this.item == "StrokeWidth") {
      this.strokeWidth += 1;
    }
    if (this.item == "Val") {
      this.val -= 5;
    }
    if (this.item == "Vertical") {
      this.translateVValue += 10;
    }
    if (this.item == "Zoom") {
      this.zoomsize += 1;
    }
    if (this.item == "Shade1") {
      this.shade1 += 1;
    }
    if (this.item == "Shade2") {
      this.shade2 += 1;
    }
    if (this.item == "Shade3") {
      this.shade3 += 1;
    }
    if (this.item == "Shade4") {
      this.shade4 += 1;
    }
    if (this.item == "Percent") {
      this.shaderpercent += 0.01;
    }
    if (this.item == "gendx") {
      this.gendx += 1;
    }
    if (this.item == "gendy") {
      this.gendy += 1;
    }
    this.item = "";
  }

  //////////////////////////

  //////////////////////////

  private outputTransform(
    rotate,
    r,
    randomRotateValue,
    scale,
    s,
    randomScaleValue,
    skewX,
    sx,
    randomSkewXValue,
    skewY,
    sy,
    randomSkewYValue,
    translate,
    th,
    randomHValue,
    tv,
    randomVValue,
    scx,
    scy,
    gendx,
    gendy,
    z,
    i
  ) {
    const toFinite = (value: any, fallback: number) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    r = toFinite(r, 0) + 2;
    sx = toFinite(sx, 0);
    sy = toFinite(sy, 0);
    th = toFinite(th, 0);
    tv = toFinite(tv, 0);
    scx = toFinite(scx, 1);
    scy = toFinite(scy, 1);

    const randomBaseKey =
      (this.shapeName || "") +
      "|" +
      (this.squareif || "") +
      "|" +
      (Number(i) || 0) +
      "|" +
      (Number(this.layers) || 0) +
      "|" +
      (Number(this.spreadsize) || 0);

    if (rotate == "rotate") {
      if (randomRotateValue == true) {
        r = this.getStableRandom(1, 360, randomBaseKey + "|rotate|" + r);
      }
      this.irotateString = "rotate(" + r + ",0,0)";
    }
    r;
    s;
    sx;
    sy;

    scx = toFinite(parseFloat(scx.toFixed(2)), 1);
    scy = toFinite(parseFloat(scy.toFixed(2)), 1);

    this.irotateString = "rotate(" + r + ",0,0)";
    this.iscaleString = "scale(" + scx + ", " + scy + ")";

    if (skewX == "skewX") {
      if (randomSkewXValue == true) {
        sx = this.getStableRandom(1, 80, randomBaseKey + "|skewX|" + sx);
      }
      this.iskewXString = "skewX(" + sx + ")";
    }

    if (skewY == "skewY") {
      if (randomSkewYValue == true) {
        sy = this.getStableRandom(1, 80, randomBaseKey + "|skewY|" + sy);
      }
      this.iskewYString = "skewY(" + sy + ")";
    }

    if (translate == "translate") {
      if (
        this.squareif === "ROUND" &&
        Number(this.numberShapes) === 1 &&
        Number(this.layers) === 1 &&
        Number(this.spreadsize) === 0
      ) {
        th = 0;
        tv = 0;
      } else if (this.squareif === "ROUND") {
        const layerIndex = Number(i) || 0;
        const totalLayers = Math.max(1, Number(this.layers) || 1);
        const radius = totalLayers > 1
          ? (Number(this.spreadsize) * layerIndex) / (totalLayers - 1)
          : Number(this.spreadsize);
        const theta = (Number(r) * Math.PI) / 180;
        th = th + (radius * Math.cos(theta));
        tv = tv + (radius * Math.sin(theta));
      }
      if (randomHValue == true) {
        th = this.getStableRandom(-900, 900, randomBaseKey + "|translateH|" + th);
      }
      if (randomVValue == true) {
        tv = this.getStableRandom(-900, 900, randomBaseKey + "|translateV|" + tv);
      }
      this.itranslateString = "translate(" + th + "," + tv + ")";
    }

    this.transformString =
      this.irotateString +
      " " +
      this.iscaleString +
      " " +
      this.iskewXString +
      " " +
      this.iskewYString +
      " " +
      this.itranslateString;

    return this.transformString;
  }

  //////////////////////////

  //////////////////////////

  private outputsquare(
    rotate,
    r,
    randomRotateValue,
    scale,
    s,
    randomScaleValue,
    skewX,
    sx,
    randomSkewXValue,
    skewY,
    sy,
    randomSkewYValue,
    translate,
    th,
    randomHValue,
    tv,
    randomVValue,
    scx,
    scy,
    gendx,
    gendy,
    z,
    dx
  ) {
    const toFinite = (value: any, fallback: number) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    r = toFinite(r, 0);
    sx = toFinite(sx, 0);
    sy = toFinite(sy, 0);
    th = toFinite(th, 0);
    tv = toFinite(tv, 0);
    gendx = toFinite(gendx, 0);
    gendy = toFinite(gendy, 0);
    scx = toFinite(scx, 1);
    scy = toFinite(scy, 1);

    // Grid-based layout for SQUARE using spread as distance between layers
    let shapex = 0;
    let shapey = 0;
    const n = Math.ceil(Math.sqrt(this.layers));
    const col = Math.floor(dx / n);
    const row = dx % n;
    
    // Use spread value as the spacing distance between layers
    // Position shapes at intervals of 'spread' units from center (th, tv)
    shapex = th + (col * gendx) - ((n - 1) / 2 * gendx);
    shapey = tv + (row * gendy) - ((n - 1) / 2 * gendy);

    const scxStr = toFinite(scx, 1).toFixed(2);
    const scyStr = toFinite(scy, 1).toFixed(2);
    const scxNum = parseFloat(scxStr);
    const scyNum = parseFloat(scyStr);

    this.irotateString = "rotate(" + r + ",0,0)";
    this.iscaleString = "scale(" + scxStr + ", " + scyStr + ")";
    this.iskewXString = "skewX(" + sx + ")";
    this.iskewYString = "skewY(" + sy + ")";

    // Apply scale centered at (0,0) by adjusting translation
    const scaleAdjustX = shapex * (1 - scxNum);
    const scaleAdjustY = shapey * (1 - scyNum);
    this.itranslateString = "translate(" + (shapex + scaleAdjustX) + "," + (shapey + scaleAdjustY) + ")";
    this.itransformString =
      this.irotateString +
      " " +
      this.iscaleString +
      " " +
      this.iskewXString +
      " " +
      this.iskewYString +
      " " +
      this.itranslateString;

    return this.itransformString;
  }

  private outputboxes(
    rotate,
    r,
    randomRotateValue,
    scale,
    s,
    randomScaleValue,
    skewX,
    sx,
    randomSkewXValue,
    skewY,
    sy,
    randomSkewYValue,
    translate,
    th,
    randomHValue,
    tv,
    randomVValue,
    scx,
    scy,
    gendx,
    gendy,
    z,
    dx
  ) {
    const toFinite = (value: any, fallback: number) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    r = toFinite(r, 0);
    sx = toFinite(sx, 0);
    sy = toFinite(sy, 0);
    th = toFinite(th, 0);
    tv = toFinite(tv, 0);
    gendx = toFinite(gendx, 0);
    gendy = toFinite(gendy, 0);
    scx = toFinite(scx, 1);
    scy = toFinite(scy, 1);

    // Spiral-based layout for BOXES using spread as distance between layers
    let shapex = th;
    let shapey = tv;
//this.gendx = this.spreadsize;
//this.gendy = this.spreadsize;

    const patternInfo = this.patternAtStep(dx);

    if (patternInfo.step > 0) {
      for (let i = 0; i < dx; i++) {
        const p = this.patternAtStep(i);
        // Use gendx for X spacing and gendy for Y spacing instead of hardcoded spread
        if (p.xExpr.includes("+spread")) {
          shapex += gendx;
        } else if (p.xExpr.includes("-spread")) {
          shapex -= gendx;
        }
        if (p.yExpr.includes("+spread")) {
          shapey += gendy;
        } else if (p.yExpr.includes("-spread")) {
          shapey -= gendy;
        }
      }
    }

    const scxStr = toFinite(scx, 1).toFixed(2);
    const scyStr = toFinite(scy, 1).toFixed(2);
    const scxNum = parseFloat(scxStr);
    const scyNum = parseFloat(scyStr);

    this.irotateString = "rotate(" + r + ",0,0)";
    this.iscaleString = "scale(" + scxStr + ", " + scyStr + ")";
    this.iskewXString = "skewX(" + sx + ")";
    this.iskewYString = "skewY(" + sy + ")";

    // Apply scale centered at (0,0) by adjusting translation
    const scaleAdjustX = shapex * (1 - scxNum);
    const scaleAdjustY = shapey * (1 - scyNum);
    this.itranslateString = "translate(" + (shapex + scaleAdjustX) + "," + (shapey + scaleAdjustY) + ")";
    this.itransformString =
      this.irotateString +
      " " +
      this.iscaleString +
      " " +
      this.iskewXString +
      " " +
      this.iskewYString +
      " " +
      this.itranslateString;

    return this.itransformString;
  }

  //////////////////////////

  //////////////////////////

  private EqualScale(scaleX, scaleY, scale) {
    this.scaleX = this.scale;
    this.scaleY = this.scale;
  }

  /////////////////////////
  private killColor() {
    const playground = document.getElementById("playground");
    if (!playground) return;

    const elements = playground.querySelectorAll<SVGElement>(
      "[fill], [stroke]"
    );
    for (let i = 0; i < elements.length; i++) {
      elements[i].removeAttribute("fill");
      elements[i].removeAttribute("stroke");
    }
  }
  //////////////////////////

  private killtom0() {
    this.tom += 1;
    this.name = "tom" + String(this.tom);

    const element = document.getElementById(this.name);
    if (element) {
      element.remove();
    }

    const element1 = document.getElementById("tom1");
    if (element1) {
      element1.remove();
    }
    this.name = "kim" + String(this.tom);

    const element22 = document.getElementById(this.name);
    if (element22) {
      element22.remove();
    }
    const element23 = document.getElementById("kim0");
    if (element23) {
      element23.remove();
    }

    const element32 = document.getElementById("kim1");
    if (element32) {
      element32.remove();
    }
  }

  //////////////////////////

  //////////////////////////


  //////////////////////////

  private squareit() {
    if (this.squareif === 'SQUARE') {
      //this.shapeName = "#base";
      this.numberShapes = 1;
      this.layers = 145;
      this.spreadsize = 220;
      //////////////////////////

      this.rotateValue = 0;
      this.scale = 1;
      //this.scaleX = 0.3;
      //this.scaleY = 0.3;
      //this.skewXValue = 0;
      //this.skewYValue = 0;
      this.translateHValue = -1600;
      this.translateVValue = -1600;
      this.gendx = 200;
      this.gendy = 200;
      this.zoomsize = 1;
      ///////////////////
      //this.shade1 = 120;
      //this.shade2 = 280;
      ///////////////////
      //this.hue = 28;
      //this.sat = 100;
      //this.val = 100;
      //this.alpha = 1;
      this.stroke = 0;
      this.strokeWidth = 2;
      this.backg = 0;
      ///////////////////
      this.imove = 0;
      this.imoveh = 0;
      this.irotate = 0;
      this.iscale = 1;
      this.iscaleX = 1;
      this.iscaleY = 1;
      this.iskewX = 0;
      this.iskewXValue = 0;
      this.iskewY = 0;
      this.iskewYValue = 0;
      this.default = 5;



    } else if (this.squareif === 'ROUND') {
      //this.shapeName = "#base";
      this.numberShapes = 5;
      this.layers = 145;
      this.spreadsize = 220;
      //////////////////////////
      this.rotateValue =190;
      this.scale = .02;
      this.scaleX = 0.3;
      this.scaleY = 0.3;
      this.skewXValue = 0;
      this.skewYValue = 0;
      this.translateHValue = 0;
      this.translateVValue = 0;
      this.gendx = 126;
      this.gendy =126;
      this.zoomsize = 1;
      ///////////////////
      this.shade1 = 120;
      this.shade2 = 280;
      ///////////////////
      this.hue = 25;
      this.sat = 100;
      this.val = 100;
      this.alpha = 1;
      this.stroke = 0;
      this.strokeWidth = 2;
      this.backg = 0;
      ///////////////////
      this.imove = 0;
      this.imoveh = 0;
      this.irotate = 0;
      this.iscale = 1;
      this.iscaleX = 1;
      this.iscaleY = 1;
      this.iskewX = 0;
      this.iskewXValue = 0;
      this.iskewY = 0;
      this.iskewYValue = 0;
    } else if (this.squareif === 'BOXES') {
      // BOXES layout logic
      this.numberShapes = 1;
      this.layers = 50;
      this.spreadsize = 120;
      this.rotateValue = 0;
      this.scale = 1;
      this.scaleX = 0.2;
      this.scaleY = 0.2;
      this.skewXValue = 0;
      this.skewYValue = 0;
      this.translateHValue = -2000;
      this.translateVValue = -1900;
      this.gendx = 326;
      this.gendy =326;
      this.zoomsize = 1;
      this.shade1 = 120;
      this.shade2 = 280;
      this.hue = 25;
      this.sat = 100;
      this.val = 100;
      this.alpha = 1;
      this.stroke = 0;
      this.strokeWidth = 2;
      this.backg = 0;
      this.imove = 0;
      this.imoveh = 0;
      this.irotate = 0;
      this.iscale = 1;
      this.iscaleX = 1;
      this.iscaleY = 1;
      this.iskewX = 0;
      this.iskewXValue = 0;
      this.iskewY = 0;
      this.iskewYValue = 0;
    }
  }

  /////////////////////////

  //////////////////////////

  private outputartdata(
    rotate,
    r,
    randomRotateValue,
    scale,
    s,
    randomScaleValue,
    skewX,
    sx,
    randomSkewXValue,
    skewY,
    sy,
    randomSkewYValue,
    translate,
    th,
    randomHValue,
    tv,
    randomVValue
  ) {
    if (rotate == "rotate") {
      if (this.randomRotateValue == true) {
        r = this.getRandom(1, 360);
      }
      this.irotateString = "rotate(" + r + ",0,0)";
    }
    r; //= this.rotateValue;
    s; //= this.scale;
    sx; //= this.iskewX;
    sy; //= this.iskewY;
    //scx = this.scaleX;
    //scy = this.scaleY;

    //scx += s; //= this.iscaleX;
    //scy += s; //= this.scaleY;

    this.irotateString = "rotate(" + r + ",0,0)";
    this.iscaleString = "scale(" + s + ", " + s + ")";

    if (skewX == "skewX") {
      if (this.randomSkewXValue == true) {
        sx = this.getRandom(1, 80);
        this.scale;
      }
      this.iskewXString = "skewX(" + sx + ")";
    }

    if (skewY == "skewY") {
      if (this.randomSkewYValue == true) {
        sy = this.getRandom(1, 80);
      }
      this.iskewYString = "skewY(" + sy + ")";
    }

    if (translate == "translate") {
      if (randomHValue == true) {
        th = this.getRandom(-900, 900);
      }
      if (randomVValue == true) {
        tv = this.getRandom(-900, 900);
      }
      this.itranslateString = "translate(" + th + "," + tv + ")";
    }

    this.transformString =
      this.irotateString +
      " " +
      this.iscaleString +
      " " +
      this.iskewXString +
      " " +
      this.iskewYString +
      " " +
      this.itranslateString;

    return this.transformString;
  }

  //////////////////////////

  //////////////////////////

  private toggleGradient(shade3, shade4) {
    this.shade3 = shade3;
    this.shade4 = shade4;
    this.rgbColor3 = this.hsv2rgba(this.shade3, this.sat, this.val, 1);
    this.rgbColor4 = this.hsv2rgba(this.shade4, this.sat, this.val, 1);

    // Generate a new gradient when toggling ON
    this.stopcolor3 = this.rgbColor3;
    this.stopcolor4 = this.rgbColor4;
    this.myshader2 =
      ` <linearGradient id="newshader2" x1="0%" y1="0%" x2="0%" y2="` +
      this.shaderpercent +
      `" > 
<stop offset="0%" style="stop-color: ${this.stopcolor3};">
</stop>
<stop offset="100%" style="stop-color: ${this.stopcolor4};" >
</stop>
</linearGradient > `;

    this.shadercode = document.getElementById("myShadeback");
    this.shadercode.innerHTML = this.myshader2;
    this.shadeFill2 = "url(#newshader2)";

    return this.shadeFill2;
  }
  /////////////////////////
  //////////////////////////
  //////////////////////////

  private togglezoom() {
    this.zoomflag += 1;
    if (this.zoomflag > 3) {
      this.zoomflag = 0;
    }
    if (this.zoomflag == 0) {
      this.zoomsize = 0;
    } else if (this.zoomflag == 1) {
      this.zoomsize = 1;
    } else if (this.zoomflag == 2) {
      this.zoomsize = this.layers;
    } else if (this.zoomflag == 3) {
      this.zoomsize = 110000000;
    }
  }

  //////////////////////////

  //////////////////////////

  private selectedShape: SVGGraphicsElement | null = null;

  // Add event listener to select shapes
  private enableShapeSelection(): void {
    this.selectedPlaygroundTarget = 'selected';
    this.selectedPlaygroundShapeId = '';
    this.playgroundAnimationMode = false;
    this.playgroundAnimationDuration = 8;
    this.playgroundAnimationStartDelay = 0;
    this.playgroundAnimationEndHold = 0;
    this.playgroundAnimationReturn = true;
    this.playgroundAnimationMirror = false;
    this.playgroundShapeCounter = 0;
  }

  // Handle shape selection
  private selectShape(shape: SVGGraphicsElement): void {
    if (this.selectedShape) {
      this.selectedShape.classList.remove("selected"); // Remove highlight
    }

    this.selectedShape = shape;
    shape.classList.add("selected"); // Add highlight

    // Preserve existing transformations
    const existingTransform = shape.getAttribute("transform") || "";
    shape.setAttribute(
      "transform",
      `${existingTransform} translate(${this.gendx}, ${this.gendy})`
    );

    this.selectedPlaygroundShapeId =
      shape.getAttribute('data-playground-shape-id') ||
      shape.id ||
      this.selectedPlaygroundShapeId;
  }
  //////////////////////////

  //////////////////////////

  private zoomin() {
    this.zoomsize = this.layers;
    this.scale = 0.03;
  }
  //////////////////////////

  //////////////////////////
  private zoomout() {
    this.zoomsize = 1;
    this.scale = 0.1;
  }

  //////////////////////////

  //////////////////////////

  //////////////////////////

  //////////////////////////
  private addPaletteColortoplayground(selectedColor) {
    selectedColor.a = this.alpha;
    if (this.pastePaletteString) {
      this.paletteString = this.pastePaletteString;
    } else {
      if (this.paletteString === "") {
        this.paletteString +=
          selectedColor.h +
          "," +
          selectedColor.s +
          "," +
          selectedColor.b +
          "," +
          selectedColor.a;
      } else {
        this.paletteString =
          this.paletteString +
          " " +
          selectedColor.h +
          "," +
          selectedColor.s +
          "," +
          selectedColor.b +
          "," +
          selectedColor.a;
      }
    }
    // this.useColor(this.paletteString);
    if (this.usepalettebox == true) {
      selectedColor.a = this.alpha;
      this.rgbColor = this.nextColor(
        selectedColor.h,
        selectedColor.s,
        selectedColor.b,
        selectedColor.a
      );
      this.pastePaletteString = "";
    }
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.playground = document.getElementById("playground").innerHTML;
    this.fillColorString = this.rgbColor;
    this.newbase =
      "<g fill=" + this.fillColorString + "> " + this.newbase + " </g> \n";
    this.playground = "<g > " + this.playground + " </g> \n";
    this.playground = this.newbase + this.playground;
    document.getElementById("playground").innerHTML = this.playground;
    this.shapeName = "#playground";
    this.shapeID = this.setShape(this.shapeName);
    this.showData = this.playground;
    this.playground1 = true;
  }

  private assignsinglecolorshapes(selectedColor) {
    this.shader1 = false;
    var hue = selectedColor.h;
    var sat = selectedColor.s;
    var val = selectedColor.b;
    var alpha = this.alpha;
    this.rgbColor1 = this.hsv2rgba(hue, sat, val, alpha);
    this.shapeID = this.setShape(this.shapeName);
    const lightningGroup = document.getElementById(this.shapeID);
    const svgNamespace = "http://www.w3.org/2000 / svg ";
    const player = document.createElementNS(svgNamespace, "g");
    const nid = this.getRandom(1, 100);
    const newid = nid.toString();
    const idname = "#player" + newid;
    player.setAttribute("fill", this.rgbColor1);
    player.setAttribute("id", idname);
    while (lightningGroup.firstChild) {
      player.appendChild(lightningGroup.firstChild);
    }


    const shape = document.getElementById("garage");
    shape.appendChild(player);
    this.shapeName = "#garage";
    this.shapeID = this.setShape(this.shapeName);
    this.showData = document.getElementById("garage").innerHTML;
    this.buildplayground();
    document.getElementById("garage").innerHTML = "";
  }

  private buildbasement() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.basement = document.getElementById("basement").innerHTML;
    this.basement = this.newbase + this.basement;
    document.getElementById("basement").innerHTML = this.basement;
    this.shapeName = "#basement";
    this.shapeID = this.setShape(this.shapeName);
    this.showData = this.basement;
    this.basement1 = true;
    this.setShape("#basement");
    this.centerShape(true);
  }

  private buildpaletteshader(rgbColor3, rgbColor4) {
    this.stopcolor3 = rgbColor3;
    this.stopcolor4 = rgbColor4;
    this.paletteshader =
      ` <linearGradient id="newpaletteshader" x1="0%" y1="0%" x2="0%" y2="` +
      this.shaderpercent +
      `" > 
            <stop offset="0%" style="stop-color: ${this.stopcolor3};">
            </stop>
            <stop offset="100%" style="stop-color: ${this.stopcolor4};">
            </stop>
            </linearGradient > `;
    var shadercode = document.getElementById("myPaletteShade");
    shadercode.innerHTML = this.paletteshader;
    this.pladeFill = "url(#newpaletteshader)";
    return this.pladeFill;
  }

  private BW() {
    if (this.backg == 0) {
      this.backg = 360;
    }
    if (this.backg == 360) {
      this.backg = 0;
    }
    return this.backg;
  }
  private changeArrayToHSVAString(colors) {
    this.colors = colors;
    this.hue = this.colors[0];
    this.sat = this.colors[1];
    this.val = this.colors[2];
    this.alpha = this.alpha;
    this.currentColor = this.colors.join(",");
    return this.currentColor;
  }
  private changeToRGBA(colors) {
    this.colors = colors;
    this.hue = this.colors[0];
    this.sat = this.colors[1];
    this.val = this.colors[2];
    this.alpha = this.alpha;
    this.rgbColor = this.hsv2rgba(this.hue, this.sat, this.val, this.alpha);
    return this.rgbColor;
  }

  private checkselection(selectedColor) {
    this.hue = selectedColor.h;
    this.sat = selectedColor.s;
    this.val = selectedColor.b;
    selectedColor.a = this.alpha;
    this.currentColor =
      this.hue + "," + this.sat + "," + this.val + "," + this.alpha;
    return this.currentColor;
  }

  private xdefaults() {
    if (this.default == 1) {
      this.irotate = 45;
      this.iscale = 3;
      this.iscaleX = 0.8;
      this.iscaleY = 0.8;
      this.iskewX = 30;
      this.iskewY = 30;
      this.imoveh = 0;
      this.imovev = 100;
      this.default = 2;
      this.lockscale = true;
    } else if (this.default == 2) {
      this.irotate = 90;
      this.iscaleX = -1;
      this.iscaleY = -1;
      this.iscale = -0.8;
      this.iskewX = -20;
      this.iskewY = -20;
      this.imoveh = -20;
      this.imovev = -20;
      this.default = 3;
      this.lockscale = false;
    } else if (this.default == 3) {
      this.irotate = 360;
      this.iscaleX = 4;
      this.iscaleY = 4;
      this.iscale = 5;
      this.iskewX = 60;
      this.iskewY = 60;
      this.imoveh = 20;
      this.imovev = 20;
      this.default = 4;
      this.lockscale = true;
    } else if (this.default == 4) {
      this.irotate = 180;
      this.iscaleX = 2;
      this.iscaleY = -5;
      this.iscale = 1;
      this.iskewX = 20;
      this.iskewY = 20;
      this.imoveh = 20;
      this.imovev = 20;
      this.default = 5;
      this.lockscale = true;
    } else if (this.default == 5) {
      this.irotate = 60;
      this.iscaleX = 1.5;
      this.iscaleY = 1.5;
      this.iscale = 0.7;
      this.iskewX = 30;
      this.iskewY = 30;
      this.imoveh = 20;
      this.imovev = 20;
      this.default = 6;
      this.lockscale = false;
    } else if (this.default == 6) {
      this.irotate = 0;
      this.iscaleX = 1;
      this.iscaleY = 1;
      this.iscale = 1;
      this.iskewX = 0;
      this.iskewY = 0;
      this.imoveh = 0;
      this.imovev = 0;
      this.default = 7;
      this.lockscale = true;
    } else if (this.default == 7) {
      this.irotate = -60;
      this.iscaleX = -1.5;
      this.iscaleY = -1.5;
      this.iscale = -3;
      this.iskewX = -10;
      this.iskewY = -10;
      this.imoveh = -200;
      this.imovev = -200;
      this.default = 1;
      this.lockscale = false;
    }
  }
  private displayShapeCode() {
    this.shapeName === "#playground";
    this.shapeID = this.setShape(this.shapeName);
    this.shapeData = "<html>\n<body>\n";
    this.shapeData = this.shapeData + '<svg id="playspace" ';
    this.shapeData = this.shapeData + 'version="1.1" ';
    this.shapeData = this.shapeData + 'xmlns="http:';
    this.shapeData = this.shapeData + 'xmlns:xlink="http:';
    this.shapeData = this.shapeData + 'x="-1000px" y="-1000px " ';
    this.shapeData = this.shapeData + 'width="2000px" height="2000px " ';
    this.shapeData = this.shapeData + 'viewBox="-1000 -1000 2000 2000">\n';
    this.shapeData = this.shapeData + '<g fill = "white" stroke="black" >\n';
    this.shapeData =
      this.shapeData + document.getElementById(this.shapeID).innerHTML;
    this.shapeData = this.shapeData + "</g>\n</svg>\n</body>\n</html>\n";
    var newTab = window.open();
    newTab.document.write(this.shapeData);
    newTab.document.close();
  }
  private downloadbasement() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.kitchen = document.getElementById("kitchen").innerHTML;
    this.kitchen = this.newbase + this.kitchen;
    document.getElementById("kitchen").innerHTML = this.kitchen;
    this.setShape("#kitchen");
    this.kitchen1 = true;
    this.downloadArt();
  }
  private downloadplayground() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.kitchen = document.getElementById("kitchen").innerHTML;
    this.kitchen = this.newbase + this.kitchen;
    document.getElementById("kitchen").innerHTML = this.kitchen;
    this.setShape("#kitchen");
    this.kitchen1 = true;
    this.downloadArt();
  }
  private exportArt(shapeName) {
    this.saveArtData();
    this.savesvgobject(shapeName);
  }
  private fileChanged(e) {
    this.file = e.target.files[0];
  }
  private fillWithWhite2rgba(hue, sat, val, alpha, r) {
    this.counter++;
    // hue = hue % 360;
    if (this.randomHueValue == true) {
      hue = this.getRandom(0, 360);
    }
    if (this.randomSatValue == true) {
      sat = this.getRandom(0, 100);
    }
    if (this.randomValValue == true) {
      val = this.getRandom(20, 100);
    }
    if (this.randomAlphaValue == true) {
      alpha = this.getRandom(10, 100) / 100;
    }
    this.currentColor = hue + "," + sat + "," + val + "," + alpha;
    this.rgbColor = this.hsv2rgba(hue, sat, val, alpha);
    this.currentFill = this.rgbColor;
    if (this.usepalettebox == true) {
      this.rgbColor = this.nextColor(hue, sat, val, alpha);
    }
    return this.rgbColor;
  }
  private flipleft() {
    this.applyPlaygroundOperation(0, 1, -1, 1, 0, 0, this.imoveh, 0);
  }
  private flipup() {
    this.applyPlaygroundOperation(0, 1, 1, -1, 0, 0, 0, this.imovev);
  }
  private getcolorpaletteshader(hue, sat, val, alpha) {
    this.shade1 = hue;
    this.currentColor = this.shade1 + "," + sat + "," + val + "," + alpha;
    this.rgbColor1 = this.hsv2rgba(this.shade1, sat, val, alpha);
    hue = this.shade2;
    this.currentColor = hue + "," + sat + "," + val + "," + alpha;
    this.rgbColor4 = this.hsv2rgba(hue, sat, val, alpha);
    this.pladeFill = this.buildpaletteshader(this.rgbColor3, this.rgbColor4);
    return this.pladeFill;
  }
  private getcolorpaste() {}
  private getcolorpicker(selectedColor) {
    this.hue = selectedColor.h;
    this.sat = selectedColor.s;
    this.val = selectedColor.b;
    this.alpha = this.alpha;
    return [this.hue, this.sat, this.val, this.alpha];
  }
  private getcolorrandom(hue, sat, val, alpha) {
    if (this.randomHueValue == true) {
      hue = this.getRandom(0, 360);
    }
    if (this.randomSatValue == true) {
      sat = this.getRandom(0, 100);
    }
    if (this.randomValValue == true) {
      val = this.getRandom(20, 100);
    }
    if (this.randomAlphaValue == true) {
      alpha = this.getRandom(10, 100) / 100;
    }
    return [hue, sat, val, alpha];
  }
  private getcolorshader(hue, sat, val, alpha) {
    this.currentColor = hue + "," + sat + "," + val + "," + alpha;
    this.rgbColor1 = this.hsv2rgba(this.shade1, sat, val, alpha);
    this.rgbColor2 = this.hsv2rgba(this.shade1, sat, val, alpha);
    this.shadeFill = this.buildshader(this.rgbColor1, this.rgbColor2);
    return this.shadeFill;
  }
  private hide(kink) {
    var block1 = document.getElementById(kink);
    if (block1.style.visibility == "visible") {
      block1.style.visibility = "hidden";
      alert(kink + ": " + block1.style.visibility);
    }
  }
  private hidestage() {
    var block1 = document.getElementById("box");
    if (block1.style.visibility == "visible") {
      block1.style.visibility = "hidden";
    } else if (block1.style.visibility == "hidden") {
      block1.style.visibility = "visible";
    } else {
      block1.style.visibility = "hidden";
    }
  }
  private insertshapetools() {
    var thetools =
      '<button class="clickit" (click)="scrollprimitives()">SHAPE MENU</button>';
    document.getElementById("toolinsert").innerHTML = thetools;
  }

  private killit(event) {
    var selectedElement = event.target;
    if (selectedElement) {
      event.preventDefault();
      alert(event.target);
      event.target.remove();
      alert(event.target);
    }
  }

  private makecoloringbook() {
    this.sat = 0;
    this.stroke = 0;
    this.strokeWidth = 2;
  }
  private movebasement() {
    var block1 = document.getElementById("backlot");
    block1.style.visibility = "visible";
    if (block1.style.left == "460px" && block1.style.top == "700px") {
      block1.style.left = "460px";
      block1.style.top = "200px";
    } else if (block1.style.left == "1000px" && block1.style.top == "200px") {
      block1.style.left = "460px";
      block1.style.top = "700px";
    } else if (block1.style.left == "460px" && block1.style.top == "200px") {
      block1.style.left = "1000px";
      block1.style.top = "200px";
    } else {
      block1.style.left = "460px";
      block1.style.top = "200px";
    }
  }

  private moveith(imoveh) {
    // this.duplicateShape = true;
    this.rememberDefaults();
    this.imoveh = this.scale * imoveh;
    this.atype = "translate";
    this.avalues =
      0 +
      " " +
      0 +
      " " +
      imoveh +
      " " +
      0 +
      " " +
      0 +
      " " +
      0 +
      " " +
      -imoveh +
      " " +
      0 +
      " " +
      0 +
      " " +
      0;
    var myset = imoveh;
    this.irotate = 0;
    this.iscaleX = 1;
    this.iscaleY = 1;
    this.iskewX = 0;
    this.iskewY = 0;
    // this.imoveh = 80;
    this.imovev = 0;
    this.processprimitive();
    this.recallDefaults();
    imoveh = myset;
  }
  private moveitv(imovev) {
    // this.duplicateShape = true;
    this.rememberDefaults();
    this.imovev = this.scale * imovev;
    this.atype = "translate";
    this.avalues =
      0 +
      " " +
      0 +
      " " +
      0 +
      " " +
      imovev +
      " " +
      0 +
      " " +
      0 +
      " " +
      0 +
      " " +
      -imovev +
      " " +
      0 +
      " " +
      0;
    var myset = imovev;
    this.irotate = 0;
    this.iscaleX = 1;
    this.iscaleY = 1;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    // this.imovev = 80
    this.processprimitive();
    this.recallDefaults();
    imovev = myset;
  }
  private outputBasement() {
    var r = this.irotate;
    var sc = this.iscale;
    var skx = this.iskewX;
    var sky = this.iskewY;
    var scx = this.iscaleX;
    var scy = this.iscaleY;
    var th = this.imoveh;
    var tv = this.imovev;
    var i = 1;
    if (this.lockscale == true) {
      this.iscaleString = "scale(" + sc + ", " + sc + ")";
    } else if (this.lockscale == false) {
      this.iscaleString = "scale(" + scx + ", " + scy + ")";
    }
    this.irotateString = "rotate(" + r + ",0,0)";
    // this.iscaleString = "scale(" + sc + ", " + sc + ")";
    this.iskewXString = "skewX(" + skx + ")";
    this.iskewYString = "skewY(" + sky + ")";
    this.itranslateString = "translate(" + th + "," + tv + ")";
    this.itransformString =
      this.irotateString +
      " " +
      this.iscaleString +
      " " +
      this.iskewXString +
      " " +
      this.iskewYString +
      " " +
      this.itranslateString;
    return this.itransformString;
  }
  private outputplayground() {
    var r = this.irotate;
    var sc = this.iscale;
    var skx = this.iskewX;
    var sky = this.iskewY;
    var scx = this.iscaleX;
    var scy = this.iscaleY;
    var th = this.imoveh;
    var tv = this.imovev;
    var i = 1;
    if (this.lockscale == true) {
      this.iscaleString = "scale(" + sc + ", " + sc + ")";
    } else if (this.lockscale == false) {
      this.iscaleString = "scale(" + scx + ", " + scy + ")";
    }
    this.irotateString = "rotate(" + r + ",0,0)";
    // this.iscaleString = "scale(" + sc + ", " + sc + ")";
    this.iskewXString = "skewX(" + skx + ")";
    this.iskewYString = "skewY(" + sky + ")";
    this.itranslateString = "translate(" + th + "," + tv + ")";
    this.itransformString =
      this.irotateString +
      " " +
      this.iscaleString +
      " " +
      this.iskewXString +
      " " +
      this.iskewYString +
      " " +
      this.itranslateString;
    return this.itransformString;
  }
  private randomFlow() {
    var count;
    for (count = 0; count < 100; count++) {
      this.mynum = Math.random();
      this.mynum = Math.floor(this.mynum);
    }
  }
  private readArtData(filenameout) {
    if (this.shapeName == "#basement") {
    } else {
      this.buildbasement();
    }
    var outputartdata;
    outputartdata = "<!DOCTYPE html >";
    outputartdata = outputartdata + ' <html lang="en" >';
    outputartdata = outputartdata + " <head>";
    outputartdata = outputartdata + ' <meta charset="utf-8" />';
    outputartdata =
      outputartdata +
      ' <meta http - equiv="X-UA-Compatible" content = "IE=edge,chrome=1" />';
    outputartdata = outputartdata + " <title>";
    outputartdata = outputartdata + this.shapeName;
    outputartdata = outputartdata + "</title>";
    outputartdata =
      outputartdata +
      ' < link href = "layout-styles.css" rel = "stylesheet" type = "text/css" media = "screen" />';
    outputartdata = outputartdata + " <style>";
    outputartdata =
      outputartdata + ".centerit { align- items: center;text - align: center;}";
    outputartdata = outputartdata + " </style>";
    outputartdata = outputartdata + " < /head> ";
    outputartdata = outputartdata + " <body > ";
    outputartdata = outputartdata + "<h2> ";
    outputartdata = outputartdata + this.shapeName;
    outputartdata = outputartdata + "</h2>";
    outputartdata = outputartdata + "< div ><em><p>arrayBar: ";
    outputartdata = outputartdata + this.numberShapes;
    outputartdata = outputartdata + " </p > <br / >";
    outputartdata = outputartdata + " <p>Spread: ";
    outputartdata = outputartdata + this.spreadsize;
    outputartdata = outputartdata + " </p > <br / >";
    outputartdata = outputartdata + " <p>Zoom: ";
    outputartdata = outputartdata + this.zoomsize;
    outputartdata = outputartdata + " </p > <br / >";
    outputartdata = outputartdata + " <p> Layers: ";
    outputartdata = outputartdata + this.layers;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> Rotate: ";
    outputartdata = outputartdata + this.rotateValue;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> Scale: ";
    outputartdata = outputartdata + this.scale;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> SkewX: ";
    outputartdata = outputartdata + this.skewXValue;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> SkewY: ";
    outputartdata = outputartdata + this.skewYValue;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> Horizontal: ";
    outputartdata = outputartdata + this.translateHValue;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> Vertical: ";
    outputartdata = outputartdata + this.translateVValue;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> Hue: ";
    outputartdata = outputartdata + this.hue;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> Sat: ";
    outputartdata = outputartdata + this.sat;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> Val: ";
    outputartdata = outputartdata + this.val;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> Alpha: ";
    outputartdata = outputartdata + this.alpha;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> StrokeColor: ";
    outputartdata = outputartdata + this.stroke;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> StrokeWidth: ";
    outputartdata = outputartdata + this.strokeWidth;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> BackgroundColor: ";
    outputartdata = outputartdata + this.backg;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> Container: ";
    outputartdata = outputartdata + this.shapeName;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> RotateRandom: ";
    outputartdata = outputartdata + this.randomRotateValue;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> ScaleRandom: ";
    outputartdata = outputartdata + this.randomScaleValue;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> SkewXRandom: ";
    outputartdata = outputartdata + this.randomSkewXValue;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> SkewYRandom: ";
    outputartdata = outputartdata + this.randomSkewYValue;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> HorizontalRandom: ";
    outputartdata = outputartdata + this.randomHValue;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> VerticalRandom: ";
    outputartdata = outputartdata + this.randomVValue;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> HueRandom: ";
    outputartdata = outputartdata + this.randomHueValue;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> SatRandom: ";
    outputartdata = outputartdata + this.randomSatValue;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> ValRandom: ";
    outputartdata = outputartdata + this.randomValValue;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> AlphaRandom: ";
    outputartdata = outputartdata + this.randomAlphaValue;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> 9StrokeColorRandom: ";
    outputartdata = outputartdata + this.randomStrokevalue;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + " <p> StrokeWidthRandom: ";
    outputartdata = outputartdata + this.randomStrokeWidthValue;
    outputartdata = outputartdata + " <br /></p > ";
    outputartdata = outputartdata + "< /em> ";
    outputartdata = outputartdata + " </div >";
    outputartdata = outputartdata + " </div> ";
    outputartdata = outputartdata + "< /body>";
    outputartdata = outputartdata + " < /html> ";
    this.filenameout = this.shapeName;
    outputartdata = outputartdata + "_ReadArtData.html";
    this.filenameout = this.filenameout.replace(/#/, "");
    this.mydownload([this.filenameout], outputartdata);
    window.open("http://localhost:4200/", this.filenameout);
  }
  private readartdatafile() {
    var newProject;
    var mynamefile;
    var fileReader;
    fileReader = new FileReader();
    mynamefile = prompt("enter filename to read");
    newProject = fileReader.readAsText(mynamefile);
    newProject = fileReader.result;
    this.processArtData(newProject);
  }
  private rockit(irock) {
    this.rememberDefaults();
    this.irotate = irock;
    this.atype = "rotate";
    this.avalues = 0 + " " + irock + " " + 0;
    var myset = irock;
    this.iscaleX = 1;
    this.iscaleY = 1;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive();
    this.recallDefaults();
    irock = myset;
  }
  private rotateit(irotate) {
    // this.duplicateShape = true;
    this.rememberDefaults();
    this.irotate = irotate;
    this.atype = "rotate";
    this.avalues = 0 + " " + irotate + " " + 0;
    var myset = irotate;
    this.iscaleX = 1;
    this.iscaleY = 1;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive();
    this.recallDefaults();
    irotate = myset;
  }

  private savesvgobject(shapeName) {
    if (this.shapeName === "#polyshape") {
      this.shapeData = document.getElementById("polyshape").innerHTML;
    } else if (this.shapeName === "#garage") {
      this.shapeData = document.getElementById("garage").innerHTML;
    } else if (this.shapeName === "#kitchen") {
      this.shapeData = document.getElementById("kitchen").innerHTML;
    } else if (this.shapeName === "#basement") {
      this.shapeData = document.getElementById("basement").innerHTML;
    } else if (this.shapeName === "#playground") {
      this.shapeData = document.getElementById("playground").innerHTML;
    } else {
      this.shapeID = this.setShape(this.shapeName);
      this.shapeData = document.getElementById(this.shapeID).innerHTML;
    }
    var dataout = this.shapeID;
    dataout = dataout + "_shape.txt";
    this.mydownload([dataout], this.shapeData);
  }
  private scrollflip() {
    document
      .getElementById("fliptoolsname")
      .scrollIntoView({ behavior: "auto" });
  }
  private scrollquick() {
    document
      .getElementById("quicknavigationblock")
      .scrollIntoView({ behavior: "auto" });
  }
  private scrollrememberartdata() {
    document
      .getElementById("rememberartdata")
      .scrollIntoView({ behavior: "auto" });
  }
  private scrollshader() {
    document.getElementById("shaderblock").scrollIntoView({ behavior: "auto" });
  }
  private scrollshapecontrol() {
    document
      .getElementById("shapecontrolname")
      .scrollIntoView({ behavior: "auto" });
  }
  private scrollShapeGenerator() {
    document
      .getElementById("shapegenerator")
      .scrollIntoView({ behavior: "auto" });
  }
  private scrollshapesliders() {
    document
      .getElementById("shapesliders")
      .scrollIntoView({ behavior: "auto" });
  }
  private scrollspecialsliders() {
    document
      .getElementById("specialsliders")
      .scrollIntoView({ behavior: "auto" });
  }
  private scrollstage() {
    document
      .getElementById("stagecontrolname")
      .scrollIntoView({ behavior: "auto" });
  }
  private scrollsvgtools() {
    document.getElementById("svgtools").scrollIntoView({ behavior: "auto" });
  }
  private scrolltoolbox() {
    document.getElementById("toolbox").scrollIntoView({ behavior: "auto" });
  }
  private scrolltools() {
    document
      .getElementById("playgroundcontrolname")
      .scrollIntoView({ behavior: "auto" });
  }
  private scrollUp(percentage) {
    var windowHeight = window.innerHeight;
    var scrollHeight = (percentage / 100) * windowHeight;
    window.scrollBy(0, scrollHeight);
  }
  private setcolor1(selectedColor) {
    this.hue = selectedColor.h;
    this.sat = selectedColor.s;
    this.val = selectedColor.b;
    this.alpha = this.alpha;
    this.rgbColor1 = this.hsv2rgba(this.hue, this.sat, this.val, this.alpha);
    return this.rgbColor1;
  }
  private setcolor2(selectedColor) {
    this.hue = selectedColor.h;
    this.sat = selectedColor.s;
    this.val = selectedColor.b;
    this.alpha = this.alpha;
    this.rgbColor2 = this.hsv2rgba(this.hue, this.sat, this.val, this.alpha);
    return this.rgbColor2;
  }
  private setcolor3(selectedColor) {
    this.hue = selectedColor.h;
    this.sat = selectedColor.s;
    this.val = selectedColor.b;
    this.alpha = this.alpha;
    this.rgbColor3 = this.hsv2rgba(this.hue, this.sat, this.val, this.alpha);
    return this.rgbColor3;
  }
  private setcolor4(selectedColor) {
    this.hue = selectedColor.h;
    this.sat = selectedColor.s;
    this.val = selectedColor.b;
    this.alpha = this.alpha;
    this.rgbColor4 = this.hsv2rgba(this.hue, this.sat, this.val, this.alpha);
    return this.rgbColor4;
  }
  private setNumberShapes(numberShapesValue) {
    this.numberShapes = numberShapesValue;
  }
  private show(kink) {
    var block1 = document.getElementById(kink);
    if (block1.style.visibility == "hidden") {
      block1.style.visibility = "visible";
      alert(kink + ": " + block1.style.visibility);
    }
  }
  private showbasement() {
    var block1 = document.getElementById("backlot");
    if (block1.style.visibility == "visible") {
      block1.style.visibility = "hidden";
    } else if (block1.style.visibility == "hidden") {
      block1.style.visibility = "visible";
    } else {
      block1.style.visibility = "visible";
    }
  }
  private svgmakebezier() {


    var myshapes = Math.floor(Math.random() * 20);
    this.bezcode = "";
    var myshapes = 1;
    var k = Math.floor(myshapes);
    var j = 0;
    while (j < k) {
      j++;
      var mysvgpoints = Math.floor(Math.random() * 10) + 4;
      var i = 0;
      var n = Math.floor(mysvgpoints);
      var x = 0;
      var y = 0;
      var line = "M ";
      x = 0;
      y = 0;
      line = line + x + "," + y + " ";
      while (i < n) {
        i++;
        line = line + "C";
        x = Math.floor(Math.random() * 500) + 100;
        y = Math.floor(Math.random() * 500) + 100;
        line = line + x + "," + y + " ";
        x = Math.floor(Math.random() * 500) + 100;
        y = Math.floor(Math.random() * 500) + 100;
        line = line + x + "," + y + " ";
        x = Math.floor(Math.random() * 500) + 100;
        y = Math.floor(Math.random() * 500) + 100;
        line = line + x + "," + y + " ";
        x = Math.floor(Math.random() * 500) + 100;
        y = Math.floor(Math.random() * 500) + 100;
        line = line + x + "," + y + " ";
      }


      var mycolor = Math.floor(Math.random() * 359) + 1;
      var myfill = "hsl(" + mycolor + ", 100%, 100%)";
      this.bezcode = this.bezcode + '<g><path class="draggable" d="';
      this.bezcode = this.bezcode + line;
      this.bezcode = this.bezcode + '0,0z"></path></g>';
      document.getElementById("playground").innerHTML = this.bezcode;
      this.setShape("#playground");
      this.lockShape = true;
    }
    return this.bezcode;
  }
  private svgmakepoly() {
    var myshapes = Math.floor(Math.random() * 20);
    this.polycode = "";
    var myshapes = 1;
    var k = Math.floor(myshapes);
    var j = 0;
    while (j < k) {
      j++;
      var mysvgpoints = Math.floor(Math.random() * 10) + 3;
      var i = 0;
      var n = Math.floor(mysvgpoints);
      var x = 0;
      var y = 0;
      var line = "";
      while (i < n) {
        i++;
        x = Math.floor(Math.random() * 500) + 100;
        y = Math.floor(Math.random() * 500) + 100;
        line = line + x + "," + y + " ";
      }
          this.gendx = -200;
          this.gendy = -200;

      this.polycode =
        this.polycode + '<g><polygon class="draggable"  points="0,0 ';
      this.polycode = this.polycode + line;
      this.polycode = this.polycode + '0,0z"></polygon></g>';
      document.getElementById("playground").innerHTML = this.polycode;
      this.setShape("#playground");
      this.showData = this.shapeName;
      this.lockShape = true;
    }
    return this.polycode;
  }
  private svgmakequadratic() {
    var myshapes = Math.floor(Math.random() * 20);
    this.quadcode = "";
    var myshapes = 1;
    var k = Math.floor(myshapes);
    var j = 0;
    while (j < k) {
      j++;
      var mysvgpoints = Math.floor(Math.random() * 10) + 3;
      var i = 0;
      var n = Math.floor(mysvgpoints);
      var x = 0;
      var y = 0;
      var line = "M ";
      x = 0;
      y = 0;
      line = line + x + "," + y + " ";
      while (i < n) {
        i++;
        line = line + "Q";
        x = Math.floor(Math.random() * 500) + 100;
        y = Math.floor(Math.random() * 500) + 100;
        line = line + x + "," + y + " ";
        x = Math.floor(Math.random() * 500) + 100;
        y = Math.floor(Math.random() * 500) + 100;
        line = line + x + "," + y + " ";
      }
          this.gendx = -200;
          this.gendy = -200;

      var mycolor = Math.floor(Math.random() * 359) + 1;
      var myfill = "hsl(" + mycolor + ",100%,100%)";
      //
      this.quadcode = this.quadcode + '<g><path class="draggable"  d="';
      this.quadcode = this.quadcode + line;
      this.quadcode = this.quadcode + 'z"></path></g>';
      document.getElementById("playground").innerHTML = this.quadcode;
      this.setShape("#playground");
      this.showData = this.shapeName;
      this.lockShape = true;
    }
    return this.quadcode;
  }

  private centerLibraryShape(shapeID: string): void {
    // Center the symbol definition in the library at (0, 0)
    const symbol = document.getElementById(shapeID);
    if (!symbol) {
      console.warn(`Symbol ${shapeID} not found in library`);
      return;
    }

    if (symbol instanceof SVGGraphicsElement) {
      try {
        const bbox = symbol.getBBox();
        const shapeCenterX = bbox.x + bbox.width / 2;
        const shapeCenterY = bbox.y + bbox.height / 2;
        
        // Calculate translation to center at (0, 0)
        const translateX = -shapeCenterX;
        const translateY = -shapeCenterY;

        // Apply transform to center the shape
        symbol.setAttribute("transform", `translate(${translateX}, ${translateY})`);
      } catch (e) {
        console.warn(`Could not center shape ${shapeID}:`, e);
      }
    }
  }

  public centerStage(): void {
    const preferredStageId = this.squareif === 'BOXES' ? 'stage1' : this.squareif === 'SQUARE' ? 'stage3' : 'stage2';
    const stageIds = [preferredStageId, 'stage1', 'stage2', 'stage3'].filter(
      (id, index, ids) => ids.indexOf(id) === index
    );

    let stageGroupEl: Element | null = null;
    for (const id of stageIds) {
      const candidate = document.getElementById(id);
      if (candidate instanceof SVGGraphicsElement) {
        stageGroupEl = candidate;
        break;
      }
    }

    if (!stageGroupEl || !(stageGroupEl instanceof SVGGraphicsElement)) {
      console.warn(`No stage group found (${stageIds.join(', ')}); unable to center.`);
      return;
    }

    let bounds: SVGRect | DOMRect;
    try {
      bounds = stageGroupEl.getBBox();
    } catch (error) {
      console.warn('Unable to compute stage bounds for centering.', error);
      return;
    }

    if (!Number.isFinite(bounds.width) || !Number.isFinite(bounds.height) || (bounds.width === 0 && bounds.height === 0)) {
      console.warn('Stage bounds are empty; nothing to center.');
      return;
    }

    const centerX = bounds.x + bounds.width / 2;
    const centerY = bounds.y + bounds.height / 2;

    if (!Number.isFinite(centerX) || !Number.isFinite(centerY)) {
      console.warn('Computed stage center is not finite; aborting center action.');
      return;
    }

    const deltaX = -centerX;
    const deltaY = -centerY;

    const currentTranslateH = Number(this.translateHValue) || 0;
    const currentTranslateV = Number(this.translateVValue) || 0;

    this.translateHValue = Number((currentTranslateH + deltaX).toFixed(2));
    this.translateVValue = Number((currentTranslateV + deltaY).toFixed(2));
  }











  public centerShape(forceAll: boolean = false): void {
    let elementsToCenter: SVGGraphicsElement[] = [];

    if (this.activeSelection.length > 0) {
      elementsToCenter = [...this.activeSelection];
    } else if (forceAll) {
      elementsToCenter = this.getAllDraggableElements();
    }

    if (elementsToCenter.length === 0) {
      console.warn('No shapes selected to center');
      return;
    }

    const result = this.centerGraphics(elementsToCenter);
    if (!result) {
      console.warn('Unable to center selection due to invalid bounds');
      return;
    }
    this.activeSelection = elementsToCenter;

    if (this.selectionBoundingBoxUpdater) {
      setTimeout(() => {
        if (this.selectionBoundingBoxUpdater) {
          this.selectionBoundingBoxUpdater();
        }
      }, 10);
    }
  }

  private getAllDraggableElements(): SVGGraphicsElement[] {
    const playground = document.getElementById('playground');
    if (!playground) {
      return [];
    }

    return Array.from(playground.querySelectorAll('.draggable')).filter(
      (element): element is SVGGraphicsElement => element instanceof SVGGraphicsElement
    );
  }

  private centerShapeCoordinates(shape: SVGGraphicsElement, translateX: number, translateY: number): void {
    this.applyGlobalTranslation(shape, translateX, translateY);
  }

  private centerPlaygroundShapePrecisely(shape: SVGGraphicsElement): void {
    const sandlotElement = document.getElementById('sandlot');
    const sandlot = sandlotElement instanceof SVGSVGElement ? sandlotElement : null;
    const desiredCenter = this.getSandlotViewportCenter(sandlot);

    const applyCenterCorrection = (): boolean => {
      const bounds = this.getBoundsInSvgCoordinates(shape, sandlot);
      if (!bounds) {
        return false;
      }

      const centerX = bounds.x + (bounds.width / 2);
      const centerY = bounds.y + (bounds.height / 2);
      this.applyGlobalTranslation(shape, desiredCenter.x - centerX, desiredCenter.y - centerY);
      return true;
    };

    if (!applyCenterCorrection()) {
      return;
    }

    const residualBounds = this.getBoundsInSvgCoordinates(shape, sandlot);
    if (!residualBounds) {
      return;
    }

    const residualX = residualBounds.x + (residualBounds.width / 2);
    const residualY = residualBounds.y + (residualBounds.height / 2);
    const dx = desiredCenter.x - residualX;
    const dy = desiredCenter.y - residualY;
    if (Math.abs(dx) > 0.01 || Math.abs(dy) > 0.01) {
      this.applyGlobalTranslation(shape, dx, dy);
    }
  }

  private getSandlotViewportCenter(sandlot: SVGSVGElement | null): { x: number; y: number } {
    if (sandlot && sandlot.viewBox && sandlot.viewBox.baseVal) {
      const viewBox = sandlot.viewBox.baseVal;
      const includesViewportOrigin =
        viewBox.x <= 0 &&
        (viewBox.x + viewBox.width) >= 0 &&
        viewBox.y <= 0 &&
        (viewBox.y + viewBox.height) >= 0;

      if (includesViewportOrigin) {
        return { x: 0, y: 0 };
      }

      return {
        x: viewBox.x + (viewBox.width / 2),
        y: viewBox.y + (viewBox.height / 2)
      };
    }

    return { x: 0, y: 0 };
  }

  private getBoundsInSvgCoordinates(
    element: SVGGraphicsElement,
    svg: SVGSVGElement | null
  ): { x: number; y: number; width: number; height: number } | null {
    if (!svg) {
      return this.computeTransformedBounds(element);
    }

    let clientRect: ClientRect | DOMRect;
    try {
      clientRect = element.getBoundingClientRect();
    } catch (error) {
      return this.computeTransformedBounds(element);
    }

    const svgCTM = svg.getScreenCTM();
    if (!svgCTM || typeof svgCTM.inverse !== 'function' || !svg.createSVGPoint) {
      return this.computeTransformedBounds(element);
    }

    const inverse = svgCTM.inverse();
    const corners = [
      { x: clientRect.left, y: clientRect.top },
      { x: clientRect.right, y: clientRect.top },
      { x: clientRect.left, y: clientRect.bottom },
      { x: clientRect.right, y: clientRect.bottom }
    ];

    const points = corners.map(corner => {
      const point = svg.createSVGPoint();
      point.x = corner.x;
      point.y = corner.y;
      return point.matrixTransform(inverse);
    });

    const xs = points.map(point => point.x);
    const ys = points.map(point => point.y);
    const minX = Math.min.apply(null, xs);
    const maxX = Math.max.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxY = Math.max.apply(null, ys);

    if (!isFinite(minX) || !isFinite(maxX) || !isFinite(minY) || !isFinite(maxY)) {
      return this.computeTransformedBounds(element);
    }

    return {
      x: minX,
      y: minY,
      width: maxX - minX,
      height: maxY - minY
    };
  }

  //////////////////////////

  //////////////////////////
    //////////////////////////

  //////////////////////////

  private centerplaygroundShape(): void {
    const playground = document.getElementById('playground');
    if (!playground) {
      return;
    }

    this.assignPlaygroundShapeIds();

    let shape: SVGGraphicsElement | null = null;

    if (this.selectedShape && playground.contains(this.selectedShape)) {
      shape = this.selectedShape;
    } else if (this.selectedPlaygroundShapeId) {
      const byId = playground.querySelector(`#${this.selectedPlaygroundShapeId}`);
      if (byId instanceof SVGGraphicsElement) {
        shape = byId;
      }
    }

    if (!shape) {
      console.warn('No selected playground shape to center');
      return;
    }

    this.centerPlaygroundShapePrecisely(shape);
    this.activeSelection = [shape];
    this.selectedShape = shape;
    this.selectedPlaygroundShapeId = shape.getAttribute('data-playground-shape-id') || shape.id || '';
  }

  //////////////////////////

  //////////////////////////
}






